/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Poker Leaderboards Admin API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptInviteBody,
  AdjustRebuyBody,
  Announcement,
  AppSettingItemResponse,
  AppSettingListResponse,
  AssignStaffBody,
  BlindStructure,
  ChangeMyPasswordBody,
  CircuitLeaderboardEntry,
  ConfirmEmailChangeBody,
  CreateAnnouncementBody,
  CreateBlindStructureBody,
  CreateFinancialEmailScheduleBody,
  CreateKnockoutBody,
  CreateLeagueBody,
  CreatePayoutStructureBody,
  CreatePlayerBody,
  CreateRegistrationBody,
  CreateResultBody,
  CreateSeasonBody,
  CreateStaffBody,
  CreateTournamentBody,
  CreateVenueBody,
  DashboardAttendanceDay,
  DashboardStats,
  DeleteResponse,
  DomainsInfo,
  ErrorResponse,
  FinancialEmailSchedule,
  FinancialEmailSendNowResponse,
  GetDashboardAttendanceParams,
  GetLapsedRegulars200,
  GetLapsedRegularsParams,
  GetLeaderboardParams,
  GetPlayerAttendanceParams,
  GetStripeConfig200,
  GetVenueUpcomingTournamentsParams,
  HeadToHead,
  HealthStatus,
  InviteInfo,
  Knockout,
  League,
  ListActiveVenueMemberships200,
  ListLoginAttemptsResponse,
  ListPlayersParams,
  ListResultsParams,
  ListStaffParams,
  ListTournamentsParams,
  LookupInviteBody,
  MyRegistration,
  NudgeLapsedRegularsBody,
  NudgeLapsedRegularsResponse,
  OkResponse,
  PaginatedLeaderboard,
  PaginatedPlayers,
  PaginatedResults,
  PaginatedTournaments,
  PayoutStructure,
  Player,
  PlayerAttendanceDay,
  PlayerHistoryEntry,
  PlayerLoginBody,
  PlayerLoginErrorResponse,
  PlayerMe,
  PlayerRequestPasswordSetupBody,
  PlayerSignupBody,
  PublicPlayerProfile,
  RefundRegistrationResponse,
  RegisteredPlayer,
  Registration,
  RegistrationCancellation,
  RegistrationRefund,
  RequestEmailChangeBody,
  RequestUploadUrlBody,
  RequestUploadUrlResponse,
  Result,
  ResultWithPlayer,
  Season,
  SetAppSettingBody,
  SetBlindLevelsBody,
  SetMyAvatarBody,
  SetPayoutTiersBody,
  SetStaffPasswordBody,
  StaffMember,
  StaffRequestPasswordResetBody,
  StripeCheckoutResponse,
  SuccessResponse,
  Tournament,
  UpdateAnnouncementBody,
  UpdateBlindStructureBody,
  UpdateFinancialEmailScheduleBody,
  UpdateLeagueBody,
  UpdateMyAccountBody,
  UpdateMyProfileBody,
  UpdatePayoutStructureBody,
  UpdatePlayerBody,
  UpdatePlayerProfileBody,
  UpdateResultBody,
  UpdateSeasonBody,
  UpdateStaffBody,
  UpdateTournamentBody,
  UpdateVenueBody,
  UpdateVenueMembershipPlanBody,
  Venue,
  VenueApplicationBody,
  VenueApplicationResponse,
  VenueConnectLink,
  VenueConnectStatus,
  VenueMembershipPlan,
  VenueRejectBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all players
 */
export const getListPlayersUrl = (params?: ListPlayersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/players?${stringifiedParams}`
    : `/api/players`;
};

export const listPlayers = async (
  params?: ListPlayersParams,
  options?: RequestInit,
): Promise<PaginatedPlayers> => {
  return customFetch<PaginatedPlayers>(getListPlayersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPlayersQueryKey = (params?: ListPlayersParams) => {
  return [`/api/players`, ...(params ? [params] : [])] as const;
};

export const getListPlayersQueryOptions = <
  TData = Awaited<ReturnType<typeof listPlayers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPlayersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPlayers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPlayersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlayers>>> = ({
    signal,
  }) => listPlayers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPlayers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPlayersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPlayers>>
>;
export type ListPlayersQueryError = ErrorType<unknown>;

/**
 * @summary List all players
 */

export function useListPlayers<
  TData = Awaited<ReturnType<typeof listPlayers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPlayersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPlayers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPlayersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a player
 */
export const getCreatePlayerUrl = () => {
  return `/api/players`;
};

export const createPlayer = async (
  createPlayerBody: CreatePlayerBody,
  options?: RequestInit,
): Promise<Player> => {
  return customFetch<Player>(getCreatePlayerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPlayerBody),
  });
};

export const getCreatePlayerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlayer>>,
    TError,
    { data: BodyType<CreatePlayerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlayer>>,
  TError,
  { data: BodyType<CreatePlayerBody> },
  TContext
> => {
  const mutationKey = ["createPlayer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlayer>>,
    { data: BodyType<CreatePlayerBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPlayer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlayerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlayer>>
>;
export type CreatePlayerMutationBody = BodyType<CreatePlayerBody>;
export type CreatePlayerMutationError = ErrorType<unknown>;

/**
 * @summary Create a player
 */
export const useCreatePlayer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlayer>>,
    TError,
    { data: BodyType<CreatePlayerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPlayer>>,
  TError,
  { data: BodyType<CreatePlayerBody> },
  TContext
> => {
  return useMutation(getCreatePlayerMutationOptions(options));
};

/**
 * @summary Get a player
 */
export const getGetPlayerUrl = (id: number) => {
  return `/api/players/${id}`;
};

export const getPlayer = async (
  id: number,
  options?: RequestInit,
): Promise<Player> => {
  return customFetch<Player>(getGetPlayerUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPlayerQueryKey = (id: number) => {
  return [`/api/players/${id}`] as const;
};

export const getGetPlayerQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlayerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayer>>> = ({
    signal,
  }) => getPlayer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPlayer>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPlayerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayer>>
>;
export type GetPlayerQueryError = ErrorType<unknown>;

/**
 * @summary Get a player
 */

export function useGetPlayer<
  TData = Awaited<ReturnType<typeof getPlayer>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlayerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a player
 */
export const getUpdatePlayerUrl = (id: number) => {
  return `/api/players/${id}`;
};

export const updatePlayer = async (
  id: number,
  updatePlayerBody: UpdatePlayerBody,
  options?: RequestInit,
): Promise<Player> => {
  return customFetch<Player>(getUpdatePlayerUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePlayerBody),
  });
};

export const getUpdatePlayerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlayer>>,
    TError,
    { id: number; data: BodyType<UpdatePlayerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlayer>>,
  TError,
  { id: number; data: BodyType<UpdatePlayerBody> },
  TContext
> => {
  const mutationKey = ["updatePlayer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlayer>>,
    { id: number; data: BodyType<UpdatePlayerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePlayer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlayerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlayer>>
>;
export type UpdatePlayerMutationBody = BodyType<UpdatePlayerBody>;
export type UpdatePlayerMutationError = ErrorType<unknown>;

/**
 * @summary Update a player
 */
export const useUpdatePlayer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlayer>>,
    TError,
    { id: number; data: BodyType<UpdatePlayerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePlayer>>,
  TError,
  { id: number; data: BodyType<UpdatePlayerBody> },
  TContext
> => {
  return useMutation(getUpdatePlayerMutationOptions(options));
};

/**
 * @summary Delete a player
 */
export const getDeletePlayerUrl = (id: number) => {
  return `/api/players/${id}`;
};

export const deletePlayer = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeletePlayerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePlayerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlayer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlayer>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePlayer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlayer>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePlayer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlayerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlayer>>
>;

export type DeletePlayerMutationError = ErrorType<unknown>;

/**
 * @summary Delete a player
 */
export const useDeletePlayer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlayer>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlayer>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePlayerMutationOptions(options));
};

/**
 * @summary Get a player's public profile (404 if private)
 */
export const getGetPublicPlayerProfileUrl = (id: number) => {
  return `/api/players/${id}/public`;
};

export const getPublicPlayerProfile = async (
  id: number,
  options?: RequestInit,
): Promise<PublicPlayerProfile> => {
  return customFetch<PublicPlayerProfile>(getGetPublicPlayerProfileUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicPlayerProfileQueryKey = (id: number) => {
  return [`/api/players/${id}/public`] as const;
};

export const getGetPublicPlayerProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicPlayerProfile>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicPlayerProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicPlayerProfileQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPublicPlayerProfile>>
  > = ({ signal }) => getPublicPlayerProfile(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicPlayerProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicPlayerProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicPlayerProfile>>
>;
export type GetPublicPlayerProfileQueryError = ErrorType<void>;

/**
 * @summary Get a player's public profile (404 if private)
 */

export function useGetPublicPlayerProfile<
  TData = Awaited<ReturnType<typeof getPublicPlayerProfile>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPublicPlayerProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicPlayerProfileQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Change the signed-in player's password
 */
export const getChangeMyPasswordUrl = () => {
  return `/api/player-auth/me/change-password`;
};

export const changeMyPassword = async (
  changeMyPasswordBody: ChangeMyPasswordBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getChangeMyPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changeMyPasswordBody),
  });
};

export const getChangeMyPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeMyPassword>>,
    TError,
    { data: BodyType<ChangeMyPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeMyPassword>>,
  TError,
  { data: BodyType<ChangeMyPasswordBody> },
  TContext
> => {
  const mutationKey = ["changeMyPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeMyPassword>>,
    { data: BodyType<ChangeMyPasswordBody> }
  > = (props) => {
    const { data } = props ?? {};

    return changeMyPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeMyPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeMyPassword>>
>;
export type ChangeMyPasswordMutationBody = BodyType<ChangeMyPasswordBody>;
export type ChangeMyPasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Change the signed-in player's password
 */
export const useChangeMyPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeMyPassword>>,
    TError,
    { data: BodyType<ChangeMyPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeMyPassword>>,
  TError,
  { data: BodyType<ChangeMyPasswordBody> },
  TContext
> => {
  return useMutation(getChangeMyPasswordMutationOptions(options));
};

/**
 * Sends a confirmation link to the new address. The address only changes once that link is opened.
 * @summary Request a verification link to change your email
 */
export const getRequestMyEmailChangeUrl = () => {
  return `/api/player-auth/me/request-email-change`;
};

export const requestMyEmailChange = async (
  requestEmailChangeBody: RequestEmailChangeBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRequestMyEmailChangeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestEmailChangeBody),
  });
};

export const getRequestMyEmailChangeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMyEmailChange>>,
    TError,
    { data: BodyType<RequestEmailChangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestMyEmailChange>>,
  TError,
  { data: BodyType<RequestEmailChangeBody> },
  TContext
> => {
  const mutationKey = ["requestMyEmailChange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestMyEmailChange>>,
    { data: BodyType<RequestEmailChangeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestMyEmailChange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestMyEmailChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestMyEmailChange>>
>;
export type RequestMyEmailChangeMutationBody = BodyType<RequestEmailChangeBody>;
export type RequestMyEmailChangeMutationError = ErrorType<void>;

/**
 * @summary Request a verification link to change your email
 */
export const useRequestMyEmailChange = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestMyEmailChange>>,
    TError,
    { data: BodyType<RequestEmailChangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestMyEmailChange>>,
  TError,
  { data: BodyType<RequestEmailChangeBody> },
  TContext
> => {
  return useMutation(getRequestMyEmailChangeMutationOptions(options));
};

/**
 * @summary Confirm a pending email change using the token from the verification email
 */
export const getConfirmMyEmailChangeUrl = () => {
  return `/api/player-auth/email-change/confirm`;
};

export const confirmMyEmailChange = async (
  confirmEmailChangeBody: ConfirmEmailChangeBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getConfirmMyEmailChangeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(confirmEmailChangeBody),
  });
};

export const getConfirmMyEmailChangeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmMyEmailChange>>,
    TError,
    { data: BodyType<ConfirmEmailChangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmMyEmailChange>>,
  TError,
  { data: BodyType<ConfirmEmailChangeBody> },
  TContext
> => {
  const mutationKey = ["confirmMyEmailChange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmMyEmailChange>>,
    { data: BodyType<ConfirmEmailChangeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return confirmMyEmailChange(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmMyEmailChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmMyEmailChange>>
>;
export type ConfirmMyEmailChangeMutationBody = BodyType<ConfirmEmailChangeBody>;
export type ConfirmMyEmailChangeMutationError = ErrorType<void>;

/**
 * @summary Confirm a pending email change using the token from the verification email
 */
export const useConfirmMyEmailChange = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmMyEmailChange>>,
    TError,
    { data: BodyType<ConfirmEmailChangeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmMyEmailChange>>,
  TError,
  { data: BodyType<ConfirmEmailChangeBody> },
  TContext
> => {
  return useMutation(getConfirmMyEmailChangeMutationOptions(options));
};

/**
 * @summary Update the signed-in player's profile preferences
 */
export const getUpdateMyProfileUrl = () => {
  return `/api/player-auth/me/profile`;
};

export const updateMyProfile = async (
  updateMyProfileBody: UpdateMyProfileBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getUpdateMyProfileUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMyProfileBody),
  });
};

export const getUpdateMyProfileMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: BodyType<UpdateMyProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: BodyType<UpdateMyProfileBody> },
  TContext
> => {
  const mutationKey = ["updateMyProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyProfile>>,
    { data: BodyType<UpdateMyProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyProfile>>
>;
export type UpdateMyProfileMutationBody = BodyType<UpdateMyProfileBody>;
export type UpdateMyProfileMutationError = ErrorType<unknown>;

/**
 * @summary Update the signed-in player's profile preferences
 */
export const useUpdateMyProfile = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyProfile>>,
    TError,
    { data: BodyType<UpdateMyProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyProfile>>,
  TError,
  { data: BodyType<UpdateMyProfileBody> },
  TContext
> => {
  return useMutation(getUpdateMyProfileMutationOptions(options));
};

/**
 * @summary Head-to-head record between this player and the signed-in viewer
 */
export const getGetPlayerHeadToHeadUrl = (id: number) => {
  return `/api/players/${id}/h2h`;
};

export const getPlayerHeadToHead = async (
  id: number,
  options?: RequestInit,
): Promise<HeadToHead> => {
  return customFetch<HeadToHead>(getGetPlayerHeadToHeadUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPlayerHeadToHeadQueryKey = (id: number) => {
  return [`/api/players/${id}/h2h`] as const;
};

export const getGetPlayerHeadToHeadQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerHeadToHead>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayerHeadToHead>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlayerHeadToHeadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerHeadToHead>>
  > = ({ signal }) => getPlayerHeadToHead(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerHeadToHead>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlayerHeadToHeadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerHeadToHead>>
>;
export type GetPlayerHeadToHeadQueryError = ErrorType<void>;

/**
 * @summary Head-to-head record between this player and the signed-in viewer
 */

export function useGetPlayerHeadToHead<
  TData = Awaited<ReturnType<typeof getPlayerHeadToHead>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayerHeadToHead>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlayerHeadToHeadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get tournament history for a player
 */
export const getGetPlayerHistoryUrl = (id: number) => {
  return `/api/players/${id}/history`;
};

export const getPlayerHistory = async (
  id: number,
  options?: RequestInit,
): Promise<PlayerHistoryEntry[]> => {
  return customFetch<PlayerHistoryEntry[]>(getGetPlayerHistoryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPlayerHistoryQueryKey = (id: number) => {
  return [`/api/players/${id}/history`] as const;
};

export const getGetPlayerHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayerHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlayerHistoryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerHistory>>
  > = ({ signal }) => getPlayerHistory(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlayerHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerHistory>>
>;
export type GetPlayerHistoryQueryError = ErrorType<unknown>;

/**
 * @summary Get tournament history for a player
 */

export function useGetPlayerHistory<
  TData = Awaited<ReturnType<typeof getPlayerHistory>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayerHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlayerHistoryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get tournament attendance days for a player (last 12 months)
 */
export const getGetPlayerAttendanceUrl = (
  id: number,
  params?: GetPlayerAttendanceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/players/${id}/attendance?${stringifiedParams}`
    : `/api/players/${id}/attendance`;
};

export const getPlayerAttendance = async (
  id: number,
  params?: GetPlayerAttendanceParams,
  options?: RequestInit,
): Promise<PlayerAttendanceDay[]> => {
  return customFetch<PlayerAttendanceDay[]>(
    getGetPlayerAttendanceUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlayerAttendanceQueryKey = (
  id: number,
  params?: GetPlayerAttendanceParams,
) => {
  return [
    `/api/players/${id}/attendance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlayerAttendanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerAttendance>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetPlayerAttendanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayerAttendance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlayerAttendanceQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlayerAttendance>>
  > = ({ signal }) =>
    getPlayerAttendance(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerAttendance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlayerAttendanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerAttendance>>
>;
export type GetPlayerAttendanceQueryError = ErrorType<unknown>;

/**
 * @summary Get tournament attendance days for a player (last 12 months)
 */

export function useGetPlayerAttendance<
  TData = Awaited<ReturnType<typeof getPlayerAttendance>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetPlayerAttendanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlayerAttendance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlayerAttendanceQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-day attendance overview across all players (last 12 months)
 */
export const getGetDashboardAttendanceUrl = (
  params?: GetDashboardAttendanceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/attendance?${stringifiedParams}`
    : `/api/dashboard/attendance`;
};

export const getDashboardAttendance = async (
  params?: GetDashboardAttendanceParams,
  options?: RequestInit,
): Promise<DashboardAttendanceDay[]> => {
  return customFetch<DashboardAttendanceDay[]>(
    getGetDashboardAttendanceUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDashboardAttendanceQueryKey = (
  params?: GetDashboardAttendanceParams,
) => {
  return [`/api/dashboard/attendance`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardAttendanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardAttendance>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardAttendanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardAttendance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardAttendanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardAttendance>>
  > = ({ signal }) =>
    getDashboardAttendance(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardAttendance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardAttendanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardAttendance>>
>;
export type GetDashboardAttendanceQueryError = ErrorType<unknown>;

/**
 * @summary Per-day attendance overview across all players (last 12 months)
 */

export function useGetDashboardAttendance<
  TData = Awaited<ReturnType<typeof getDashboardAttendance>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardAttendanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardAttendance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardAttendanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all leagues
 */
export const getListLeaguesUrl = () => {
  return `/api/leagues`;
};

export const listLeagues = async (options?: RequestInit): Promise<League[]> => {
  return customFetch<League[]>(getListLeaguesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListLeaguesQueryKey = () => {
  return [`/api/leagues`] as const;
};

export const getListLeaguesQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeagues>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLeagues>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeaguesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeagues>>> = ({
    signal,
  }) => listLeagues({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeagues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeaguesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeagues>>
>;
export type ListLeaguesQueryError = ErrorType<unknown>;

/**
 * @summary List all leagues
 */

export function useListLeagues<
  TData = Awaited<ReturnType<typeof listLeagues>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLeagues>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeaguesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a league
 */
export const getCreateLeagueUrl = () => {
  return `/api/leagues`;
};

export const createLeague = async (
  createLeagueBody: CreateLeagueBody,
  options?: RequestInit,
): Promise<League> => {
  return customFetch<League>(getCreateLeagueUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLeagueBody),
  });
};

export const getCreateLeagueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLeague>>,
    TError,
    { data: BodyType<CreateLeagueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLeague>>,
  TError,
  { data: BodyType<CreateLeagueBody> },
  TContext
> => {
  const mutationKey = ["createLeague"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLeague>>,
    { data: BodyType<CreateLeagueBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createLeague(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLeagueMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLeague>>
>;
export type CreateLeagueMutationBody = BodyType<CreateLeagueBody>;
export type CreateLeagueMutationError = ErrorType<unknown>;

/**
 * @summary Create a league
 */
export const useCreateLeague = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLeague>>,
    TError,
    { data: BodyType<CreateLeagueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLeague>>,
  TError,
  { data: BodyType<CreateLeagueBody> },
  TContext
> => {
  return useMutation(getCreateLeagueMutationOptions(options));
};

/**
 * @summary Get a league
 */
export const getGetLeagueUrl = (id: number) => {
  return `/api/leagues/${id}`;
};

export const getLeague = async (
  id: number,
  options?: RequestInit,
): Promise<League> => {
  return customFetch<League>(getGetLeagueUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLeagueQueryKey = (id: number) => {
  return [`/api/leagues/${id}`] as const;
};

export const getGetLeagueQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeague>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLeagueQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeague>>> = ({
    signal,
  }) => getLeague(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getLeague>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetLeagueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeague>>
>;
export type GetLeagueQueryError = ErrorType<unknown>;

/**
 * @summary Get a league
 */

export function useGetLeague<
  TData = Awaited<ReturnType<typeof getLeague>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeague>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeagueQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a league
 */
export const getUpdateLeagueUrl = (id: number) => {
  return `/api/leagues/${id}`;
};

export const updateLeague = async (
  id: number,
  updateLeagueBody: UpdateLeagueBody,
  options?: RequestInit,
): Promise<League> => {
  return customFetch<League>(getUpdateLeagueUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLeagueBody),
  });
};

export const getUpdateLeagueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeague>>,
    TError,
    { id: number; data: BodyType<UpdateLeagueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLeague>>,
  TError,
  { id: number; data: BodyType<UpdateLeagueBody> },
  TContext
> => {
  const mutationKey = ["updateLeague"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLeague>>,
    { id: number; data: BodyType<UpdateLeagueBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLeague(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLeagueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLeague>>
>;
export type UpdateLeagueMutationBody = BodyType<UpdateLeagueBody>;
export type UpdateLeagueMutationError = ErrorType<unknown>;

/**
 * @summary Update a league
 */
export const useUpdateLeague = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeague>>,
    TError,
    { id: number; data: BodyType<UpdateLeagueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLeague>>,
  TError,
  { id: number; data: BodyType<UpdateLeagueBody> },
  TContext
> => {
  return useMutation(getUpdateLeagueMutationOptions(options));
};

/**
 * @summary Delete a league
 */
export const getDeleteLeagueUrl = (id: number) => {
  return `/api/leagues/${id}`;
};

export const deleteLeague = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteLeagueUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLeagueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLeague>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLeague>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteLeague"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLeague>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLeague(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLeagueMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLeague>>
>;

export type DeleteLeagueMutationError = ErrorType<unknown>;

/**
 * @summary Delete a league
 */
export const useDeleteLeague = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLeague>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLeague>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteLeagueMutationOptions(options));
};

/**
 * @summary List all venues
 */
export const getListVenuesUrl = () => {
  return `/api/venues`;
};

export const listVenues = async (options?: RequestInit): Promise<Venue[]> => {
  return customFetch<Venue[]>(getListVenuesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListVenuesQueryKey = () => {
  return [`/api/venues`] as const;
};

export const getListVenuesQueryOptions = <
  TData = Awaited<ReturnType<typeof listVenues>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listVenues>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVenuesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listVenues>>> = ({
    signal,
  }) => listVenues({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVenues>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVenuesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVenues>>
>;
export type ListVenuesQueryError = ErrorType<unknown>;

/**
 * @summary List all venues
 */

export function useListVenues<
  TData = Awaited<ReturnType<typeof listVenues>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listVenues>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVenuesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a venue
 */
export const getCreateVenueUrl = () => {
  return `/api/venues`;
};

export const createVenue = async (
  createVenueBody: CreateVenueBody,
  options?: RequestInit,
): Promise<Venue> => {
  return customFetch<Venue>(getCreateVenueUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVenueBody),
  });
};

export const getCreateVenueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVenue>>,
    TError,
    { data: BodyType<CreateVenueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVenue>>,
  TError,
  { data: BodyType<CreateVenueBody> },
  TContext
> => {
  const mutationKey = ["createVenue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVenue>>,
    { data: BodyType<CreateVenueBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createVenue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVenue>>
>;
export type CreateVenueMutationBody = BodyType<CreateVenueBody>;
export type CreateVenueMutationError = ErrorType<unknown>;

/**
 * @summary Create a venue
 */
export const useCreateVenue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVenue>>,
    TError,
    { data: BodyType<CreateVenueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVenue>>,
  TError,
  { data: BodyType<CreateVenueBody> },
  TContext
> => {
  return useMutation(getCreateVenueMutationOptions(options));
};

/**
 * @summary Get a venue
 */
export const getGetVenueUrl = (id: number) => {
  return `/api/venues/${id}`;
};

export const getVenue = async (
  id: number,
  options?: RequestInit,
): Promise<Venue> => {
  return customFetch<Venue>(getGetVenueUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVenueQueryKey = (id: number) => {
  return [`/api/venues/${id}`] as const;
};

export const getGetVenueQueryOptions = <
  TData = Awaited<ReturnType<typeof getVenue>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenue>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVenueQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenue>>> = ({
    signal,
  }) => getVenue(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getVenue>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetVenueQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVenue>>
>;
export type GetVenueQueryError = ErrorType<unknown>;

/**
 * @summary Get a venue
 */

export function useGetVenue<
  TData = Awaited<ReturnType<typeof getVenue>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenue>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVenueQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a venue
 */
export const getUpdateVenueUrl = (id: number) => {
  return `/api/venues/${id}`;
};

export const updateVenue = async (
  id: number,
  updateVenueBody: UpdateVenueBody,
  options?: RequestInit,
): Promise<Venue> => {
  return customFetch<Venue>(getUpdateVenueUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVenueBody),
  });
};

export const getUpdateVenueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVenue>>,
    TError,
    { id: number; data: BodyType<UpdateVenueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVenue>>,
  TError,
  { id: number; data: BodyType<UpdateVenueBody> },
  TContext
> => {
  const mutationKey = ["updateVenue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVenue>>,
    { id: number; data: BodyType<UpdateVenueBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVenue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVenue>>
>;
export type UpdateVenueMutationBody = BodyType<UpdateVenueBody>;
export type UpdateVenueMutationError = ErrorType<unknown>;

/**
 * @summary Update a venue
 */
export const useUpdateVenue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVenue>>,
    TError,
    { id: number; data: BodyType<UpdateVenueBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVenue>>,
  TError,
  { id: number; data: BodyType<UpdateVenueBody> },
  TContext
> => {
  return useMutation(getUpdateVenueMutationOptions(options));
};

/**
 * @summary Delete a venue
 */
export const getDeleteVenueUrl = (id: number) => {
  return `/api/venues/${id}`;
};

export const deleteVenue = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteVenueUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVenueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVenue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVenue>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteVenue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVenue>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVenue(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVenue>>
>;

export type DeleteVenueMutationError = ErrorType<unknown>;

/**
 * @summary Delete a venue
 */
export const useDeleteVenue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVenue>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVenue>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteVenueMutationOptions(options));
};

/**
 * @summary List venue membership plans (Monthly + Yearly)
 */
export const getListVenueMembershipPlansUrl = () => {
  return `/api/venue-membership-plans`;
};

export const listVenueMembershipPlans = async (
  options?: RequestInit,
): Promise<VenueMembershipPlan[]> => {
  return customFetch<VenueMembershipPlan[]>(getListVenueMembershipPlansUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListVenueMembershipPlansQueryKey = () => {
  return [`/api/venue-membership-plans`] as const;
};

export const getListVenueMembershipPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof listVenueMembershipPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listVenueMembershipPlans>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVenueMembershipPlansQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVenueMembershipPlans>>
  > = ({ signal }) => listVenueMembershipPlans({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVenueMembershipPlans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVenueMembershipPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVenueMembershipPlans>>
>;
export type ListVenueMembershipPlansQueryError = ErrorType<unknown>;

/**
 * @summary List venue membership plans (Monthly + Yearly)
 */

export function useListVenueMembershipPlans<
  TData = Awaited<ReturnType<typeof listVenueMembershipPlans>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listVenueMembershipPlans>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVenueMembershipPlansQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Owner-only — set the price (and active flag) for a plan
 */
export const getUpdateVenueMembershipPlanUrl = (
  interval: "monthly" | "yearly",
) => {
  return `/api/venue-membership-plans/${interval}`;
};

export const updateVenueMembershipPlan = async (
  interval: "monthly" | "yearly",
  updateVenueMembershipPlanBody: UpdateVenueMembershipPlanBody,
  options?: RequestInit,
): Promise<VenueMembershipPlan> => {
  return customFetch<VenueMembershipPlan>(
    getUpdateVenueMembershipPlanUrl(interval),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateVenueMembershipPlanBody),
    },
  );
};

export const getUpdateVenueMembershipPlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVenueMembershipPlan>>,
    TError,
    {
      interval: "monthly" | "yearly";
      data: BodyType<UpdateVenueMembershipPlanBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVenueMembershipPlan>>,
  TError,
  {
    interval: "monthly" | "yearly";
    data: BodyType<UpdateVenueMembershipPlanBody>;
  },
  TContext
> => {
  const mutationKey = ["updateVenueMembershipPlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVenueMembershipPlan>>,
    {
      interval: "monthly" | "yearly";
      data: BodyType<UpdateVenueMembershipPlanBody>;
    }
  > = (props) => {
    const { interval, data } = props ?? {};

    return updateVenueMembershipPlan(interval, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVenueMembershipPlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVenueMembershipPlan>>
>;
export type UpdateVenueMembershipPlanMutationBody =
  BodyType<UpdateVenueMembershipPlanBody>;
export type UpdateVenueMembershipPlanMutationError = ErrorType<unknown>;

/**
 * @summary Owner-only — set the price (and active flag) for a plan
 */
export const useUpdateVenueMembershipPlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVenueMembershipPlan>>,
    TError,
    {
      interval: "monthly" | "yearly";
      data: BodyType<UpdateVenueMembershipPlanBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVenueMembershipPlan>>,
  TError,
  {
    interval: "monthly" | "yearly";
    data: BodyType<UpdateVenueMembershipPlanBody>;
  },
  TContext
> => {
  return useMutation(getUpdateVenueMembershipPlanMutationOptions(options));
};

/**
 * @summary Owner-only — list venues with platform membership subscriptions
 */
export const getListActiveVenueMembershipsUrl = () => {
  return `/api/venue-memberships/active`;
};

export const listActiveVenueMemberships = async (
  options?: RequestInit,
): Promise<ListActiveVenueMemberships200> => {
  return customFetch<ListActiveVenueMemberships200>(
    getListActiveVenueMembershipsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListActiveVenueMembershipsQueryKey = () => {
  return [`/api/venue-memberships/active`] as const;
};

export const getListActiveVenueMembershipsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveVenueMemberships>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveVenueMemberships>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListActiveVenueMembershipsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveVenueMemberships>>
  > = ({ signal }) => listActiveVenueMemberships({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveVenueMemberships>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveVenueMembershipsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveVenueMemberships>>
>;
export type ListActiveVenueMembershipsQueryError = ErrorType<unknown>;

/**
 * @summary Owner-only — list venues with platform membership subscriptions
 */

export function useListActiveVenueMemberships<
  TData = Awaited<ReturnType<typeof listActiveVenueMemberships>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveVenueMemberships>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveVenueMembershipsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Owner-only — cancel a venue's Stripe subscription and suspend it
 */
export const getDeactivateVenueMembershipUrl = (id: number) => {
  return `/api/venues/${id}/deactivate`;
};

export const deactivateVenueMembership = async (
  id: number,
  options?: RequestInit,
): Promise<Venue> => {
  return customFetch<Venue>(getDeactivateVenueMembershipUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDeactivateVenueMembershipMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateVenueMembership>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateVenueMembership>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deactivateVenueMembership"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateVenueMembership>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deactivateVenueMembership(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateVenueMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateVenueMembership>>
>;

export type DeactivateVenueMembershipMutationError = ErrorType<unknown>;

/**
 * @summary Owner-only — cancel a venue's Stripe subscription and suspend it
 */
export const useDeactivateVenueMembership = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateVenueMembership>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deactivateVenueMembership>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeactivateVenueMembershipMutationOptions(options));
};

/**
 * @summary Owner-only — list pending venue applications
 */
export const getListPendingVenueApplicationsUrl = () => {
  return `/api/venue-applications`;
};

export const listPendingVenueApplications = async (
  options?: RequestInit,
): Promise<Venue[]> => {
  return customFetch<Venue[]>(getListPendingVenueApplicationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPendingVenueApplicationsQueryKey = () => {
  return [`/api/venue-applications`] as const;
};

export const getListPendingVenueApplicationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPendingVenueApplications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPendingVenueApplications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPendingVenueApplicationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPendingVenueApplications>>
  > = ({ signal }) =>
    listPendingVenueApplications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPendingVenueApplications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPendingVenueApplicationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPendingVenueApplications>>
>;
export type ListPendingVenueApplicationsQueryError = ErrorType<unknown>;

/**
 * @summary Owner-only — list pending venue applications
 */

export function useListPendingVenueApplications<
  TData = Awaited<ReturnType<typeof listPendingVenueApplications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPendingVenueApplications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPendingVenueApplicationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Public — submit a venue application + start Stripe Checkout subscription
 */
export const getCreateVenueApplicationUrl = () => {
  return `/api/venue-applications`;
};

export const createVenueApplication = async (
  venueApplicationBody: VenueApplicationBody,
  options?: RequestInit,
): Promise<VenueApplicationResponse> => {
  return customFetch<VenueApplicationResponse>(getCreateVenueApplicationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(venueApplicationBody),
  });
};

export const getCreateVenueApplicationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVenueApplication>>,
    TError,
    { data: BodyType<VenueApplicationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVenueApplication>>,
  TError,
  { data: BodyType<VenueApplicationBody> },
  TContext
> => {
  const mutationKey = ["createVenueApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVenueApplication>>,
    { data: BodyType<VenueApplicationBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createVenueApplication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVenueApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVenueApplication>>
>;
export type CreateVenueApplicationMutationBody = BodyType<VenueApplicationBody>;
export type CreateVenueApplicationMutationError = ErrorType<unknown>;

/**
 * @summary Public — submit a venue application + start Stripe Checkout subscription
 */
export const useCreateVenueApplication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVenueApplication>>,
    TError,
    { data: BodyType<VenueApplicationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVenueApplication>>,
  TError,
  { data: BodyType<VenueApplicationBody> },
  TContext
> => {
  return useMutation(getCreateVenueApplicationMutationOptions(options));
};

/**
 * @summary Owner-only — approve a pending venue
 */
export const getApproveVenueApplicationUrl = (id: number) => {
  return `/api/venue-applications/${id}/approve`;
};

export const approveVenueApplication = async (
  id: number,
  options?: RequestInit,
): Promise<Venue> => {
  return customFetch<Venue>(getApproveVenueApplicationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getApproveVenueApplicationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveVenueApplication>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveVenueApplication>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["approveVenueApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveVenueApplication>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return approveVenueApplication(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveVenueApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveVenueApplication>>
>;

export type ApproveVenueApplicationMutationError = ErrorType<unknown>;

/**
 * @summary Owner-only — approve a pending venue
 */
export const useApproveVenueApplication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveVenueApplication>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveVenueApplication>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getApproveVenueApplicationMutationOptions(options));
};

/**
 * @summary Owner-only — reject a pending venue
 */
export const getRejectVenueApplicationUrl = (id: number) => {
  return `/api/venue-applications/${id}/reject`;
};

export const rejectVenueApplication = async (
  id: number,
  venueRejectBody?: VenueRejectBody,
  options?: RequestInit,
): Promise<Venue> => {
  return customFetch<Venue>(getRejectVenueApplicationUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(venueRejectBody),
  });
};

export const getRejectVenueApplicationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectVenueApplication>>,
    TError,
    { id: number; data: BodyType<VenueRejectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectVenueApplication>>,
  TError,
  { id: number; data: BodyType<VenueRejectBody> },
  TContext
> => {
  const mutationKey = ["rejectVenueApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectVenueApplication>>,
    { id: number; data: BodyType<VenueRejectBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectVenueApplication(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectVenueApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectVenueApplication>>
>;
export type RejectVenueApplicationMutationBody = BodyType<VenueRejectBody>;
export type RejectVenueApplicationMutationError = ErrorType<unknown>;

/**
 * @summary Owner-only — reject a pending venue
 */
export const useRejectVenueApplication = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectVenueApplication>>,
    TError,
    { id: number; data: BodyType<VenueRejectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectVenueApplication>>,
  TError,
  { id: number; data: BodyType<VenueRejectBody> },
  TContext
> => {
  return useMutation(getRejectVenueApplicationMutationOptions(options));
};

/**
 * @summary Create a Stripe Connect onboarding link for a venue
 */
export const getCreateVenueConnectOnboardingLinkUrl = (id: number) => {
  return `/api/venues/${id}/connect/onboarding-link`;
};

export const createVenueConnectOnboardingLink = async (
  id: number,
  options?: RequestInit,
): Promise<VenueConnectLink> => {
  return customFetch<VenueConnectLink>(
    getCreateVenueConnectOnboardingLinkUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCreateVenueConnectOnboardingLinkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVenueConnectOnboardingLink>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVenueConnectOnboardingLink>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["createVenueConnectOnboardingLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVenueConnectOnboardingLink>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return createVenueConnectOnboardingLink(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVenueConnectOnboardingLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVenueConnectOnboardingLink>>
>;

export type CreateVenueConnectOnboardingLinkMutationError = ErrorType<unknown>;

/**
 * @summary Create a Stripe Connect onboarding link for a venue
 */
export const useCreateVenueConnectOnboardingLink = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVenueConnectOnboardingLink>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVenueConnectOnboardingLink>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(
    getCreateVenueConnectOnboardingLinkMutationOptions(options),
  );
};

/**
 * @summary Live Stripe Connect onboarding status
 */
export const getGetVenueConnectStatusUrl = (id: number) => {
  return `/api/venues/${id}/connect/status`;
};

export const getVenueConnectStatus = async (
  id: number,
  options?: RequestInit,
): Promise<VenueConnectStatus> => {
  return customFetch<VenueConnectStatus>(getGetVenueConnectStatusUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVenueConnectStatusQueryKey = (id: number) => {
  return [`/api/venues/${id}/connect/status`] as const;
};

export const getGetVenueConnectStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getVenueConnectStatus>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenueConnectStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVenueConnectStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVenueConnectStatus>>
  > = ({ signal }) => getVenueConnectStatus(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVenueConnectStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVenueConnectStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVenueConnectStatus>>
>;
export type GetVenueConnectStatusQueryError = ErrorType<unknown>;

/**
 * @summary Live Stripe Connect onboarding status
 */

export function useGetVenueConnectStatus<
  TData = Awaited<ReturnType<typeof getVenueConnectStatus>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenueConnectStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVenueConnectStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the next upcoming tournaments at a venue
 */
export const getGetVenueUpcomingTournamentsUrl = (
  id: number,
  params?: GetVenueUpcomingTournamentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/venues/${id}/upcoming?${stringifiedParams}`
    : `/api/venues/${id}/upcoming`;
};

export const getVenueUpcomingTournaments = async (
  id: number,
  params?: GetVenueUpcomingTournamentsParams,
  options?: RequestInit,
): Promise<Tournament[]> => {
  return customFetch<Tournament[]>(
    getGetVenueUpcomingTournamentsUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetVenueUpcomingTournamentsQueryKey = (
  id: number,
  params?: GetVenueUpcomingTournamentsParams,
) => {
  return [`/api/venues/${id}/upcoming`, ...(params ? [params] : [])] as const;
};

export const getGetVenueUpcomingTournamentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getVenueUpcomingTournaments>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetVenueUpcomingTournamentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenueUpcomingTournaments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetVenueUpcomingTournamentsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVenueUpcomingTournaments>>
  > = ({ signal }) =>
    getVenueUpcomingTournaments(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVenueUpcomingTournaments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVenueUpcomingTournamentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVenueUpcomingTournaments>>
>;
export type GetVenueUpcomingTournamentsQueryError = ErrorType<unknown>;

/**
 * @summary Get the next upcoming tournaments at a venue
 */

export function useGetVenueUpcomingTournaments<
  TData = Awaited<ReturnType<typeof getVenueUpcomingTournaments>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  params?: GetVenueUpcomingTournamentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenueUpcomingTournaments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVenueUpcomingTournamentsQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all staff
 */
export const getListStaffUrl = (params?: ListStaffParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/staff?${stringifiedParams}`
    : `/api/staff`;
};

export const listStaff = async (
  params?: ListStaffParams,
  options?: RequestInit,
): Promise<StaffMember[]> => {
  return customFetch<StaffMember[]>(getListStaffUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStaffQueryKey = (params?: ListStaffParams) => {
  return [`/api/staff`, ...(params ? [params] : [])] as const;
};

export const getListStaffQueryOptions = <
  TData = Awaited<ReturnType<typeof listStaff>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStaffParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListStaffQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listStaff>>> = ({
    signal,
  }) => listStaff(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listStaff>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListStaffQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStaff>>
>;
export type ListStaffQueryError = ErrorType<unknown>;

/**
 * @summary List all staff
 */

export function useListStaff<
  TData = Awaited<ReturnType<typeof listStaff>>,
  TError = ErrorType<unknown>,
>(
  params?: ListStaffParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListStaffQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Invite a staff member
 */
export const getCreateStaffUrl = () => {
  return `/api/staff`;
};

export const createStaff = async (
  createStaffBody: CreateStaffBody,
  options?: RequestInit,
): Promise<StaffMember> => {
  return customFetch<StaffMember>(getCreateStaffUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createStaffBody),
  });
};

export const getCreateStaffMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStaff>>,
    TError,
    { data: BodyType<CreateStaffBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStaff>>,
  TError,
  { data: BodyType<CreateStaffBody> },
  TContext
> => {
  const mutationKey = ["createStaff"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStaff>>,
    { data: BodyType<CreateStaffBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createStaff(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStaffMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStaff>>
>;
export type CreateStaffMutationBody = BodyType<CreateStaffBody>;
export type CreateStaffMutationError = ErrorType<unknown>;

/**
 * @summary Invite a staff member
 */
export const useCreateStaff = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStaff>>,
    TError,
    { data: BodyType<CreateStaffBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStaff>>,
  TError,
  { data: BodyType<CreateStaffBody> },
  TContext
> => {
  return useMutation(getCreateStaffMutationOptions(options));
};

/**
 * @summary Get a staff member
 */
export const getGetStaffUrl = (id: number) => {
  return `/api/staff/${id}`;
};

export const getStaff = async (
  id: number,
  options?: RequestInit,
): Promise<StaffMember> => {
  return customFetch<StaffMember>(getGetStaffUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetStaffQueryKey = (id: number) => {
  return [`/api/staff/${id}`] as const;
};

export const getGetStaffQueryOptions = <
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStaffQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStaff>>> = ({
    signal,
  }) => getStaff(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getStaff>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetStaffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStaff>>
>;
export type GetStaffQueryError = ErrorType<unknown>;

/**
 * @summary Get a staff member
 */

export function useGetStaff<
  TData = Awaited<ReturnType<typeof getStaff>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStaffQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a staff member
 */
export const getUpdateStaffUrl = (id: number) => {
  return `/api/staff/${id}`;
};

export const updateStaff = async (
  id: number,
  updateStaffBody: UpdateStaffBody,
  options?: RequestInit,
): Promise<StaffMember> => {
  return customFetch<StaffMember>(getUpdateStaffUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateStaffBody),
  });
};

export const getUpdateStaffMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaff>>,
    TError,
    { id: number; data: BodyType<UpdateStaffBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStaff>>,
  TError,
  { id: number; data: BodyType<UpdateStaffBody> },
  TContext
> => {
  const mutationKey = ["updateStaff"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStaff>>,
    { id: number; data: BodyType<UpdateStaffBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStaff(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStaffMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStaff>>
>;
export type UpdateStaffMutationBody = BodyType<UpdateStaffBody>;
export type UpdateStaffMutationError = ErrorType<unknown>;

/**
 * @summary Update a staff member
 */
export const useUpdateStaff = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStaff>>,
    TError,
    { id: number; data: BodyType<UpdateStaffBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateStaff>>,
  TError,
  { id: number; data: BodyType<UpdateStaffBody> },
  TContext
> => {
  return useMutation(getUpdateStaffMutationOptions(options));
};

/**
 * @summary Delete a staff member
 */
export const getDeleteStaffUrl = (id: number) => {
  return `/api/staff/${id}`;
};

export const deleteStaff = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteStaffUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteStaffMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStaff>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteStaff>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteStaff"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteStaff>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteStaff(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteStaffMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteStaff>>
>;

export type DeleteStaffMutationError = ErrorType<unknown>;

/**
 * @summary Delete a staff member
 */
export const useDeleteStaff = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteStaff>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteStaff>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteStaffMutationOptions(options));
};

/**
 * @summary Revoke an outstanding (unused) invite for a staff member
 */
export const getRevokeStaffInviteUrl = (id: number) => {
  return `/api/staff/${id}/invite`;
};

export const revokeStaffInvite = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRevokeStaffInviteUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRevokeStaffInviteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeStaffInvite>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revokeStaffInvite>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revokeStaffInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revokeStaffInvite>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revokeStaffInvite(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevokeStaffInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof revokeStaffInvite>>
>;

export type RevokeStaffInviteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Revoke an outstanding (unused) invite for a staff member
 */
export const useRevokeStaffInvite = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revokeStaffInvite>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revokeStaffInvite>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRevokeStaffInviteMutationOptions(options));
};

/**
 * Public. Creates a new player record with a hashed password and issues
an HttpOnly session cookie.

 * @summary Create a player account with a password
 */
export const getPlayerSignupUrl = () => {
  return `/api/player-auth/signup`;
};

export const playerSignup = async (
  playerSignupBody: PlayerSignupBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getPlayerSignupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(playerSignupBody),
  });
};

export const getPlayerSignupMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playerSignup>>,
    TError,
    { data: BodyType<PlayerSignupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playerSignup>>,
  TError,
  { data: BodyType<PlayerSignupBody> },
  TContext
> => {
  const mutationKey = ["playerSignup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playerSignup>>,
    { data: BodyType<PlayerSignupBody> }
  > = (props) => {
    const { data } = props ?? {};

    return playerSignup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayerSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof playerSignup>>
>;
export type PlayerSignupMutationBody = BodyType<PlayerSignupBody>;
export type PlayerSignupMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a player account with a password
 */
export const usePlayerSignup = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playerSignup>>,
    TError,
    { data: BodyType<PlayerSignupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof playerSignup>>,
  TError,
  { data: BodyType<PlayerSignupBody> },
  TContext
> => {
  return useMutation(getPlayerSignupMutationOptions(options));
};

/**
 * @summary Sign in a player with email and password
 */
export const getPlayerLoginUrl = () => {
  return `/api/player-auth/login`;
};

export const playerLogin = async (
  playerLoginBody: PlayerLoginBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getPlayerLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(playerLoginBody),
  });
};

export const getPlayerLoginMutationOptions = <
  TError = ErrorType<PlayerLoginErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playerLogin>>,
    TError,
    { data: BodyType<PlayerLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playerLogin>>,
  TError,
  { data: BodyType<PlayerLoginBody> },
  TContext
> => {
  const mutationKey = ["playerLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playerLogin>>,
    { data: BodyType<PlayerLoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return playerLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayerLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof playerLogin>>
>;
export type PlayerLoginMutationBody = BodyType<PlayerLoginBody>;
export type PlayerLoginMutationError = ErrorType<
  PlayerLoginErrorResponse | ErrorResponse
>;

/**
 * @summary Sign in a player with email and password
 */
export const usePlayerLogin = <
  TError = ErrorType<PlayerLoginErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playerLogin>>,
    TError,
    { data: BodyType<PlayerLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof playerLogin>>,
  TError,
  { data: BodyType<PlayerLoginBody> },
  TContext
> => {
  return useMutation(getPlayerLoginMutationOptions(options));
};

/**
 * @summary Clear the player session cookie
 */
export const getPlayerLogoutUrl = () => {
  return `/api/player-auth/logout`;
};

export const playerLogout = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getPlayerLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getPlayerLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playerLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof playerLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["playerLogout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof playerLogout>>,
    void
  > = () => {
    return playerLogout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlayerLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof playerLogout>>
>;

export type PlayerLogoutMutationError = ErrorType<unknown>;

/**
 * @summary Clear the player session cookie
 */
export const usePlayerLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof playerLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof playerLogout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPlayerLogoutMutationOptions(options));
};

/**
 * @summary Update the signed-in player's name or phone
 */
export const getUpdateMyAccountUrl = () => {
  return `/api/player-auth/me`;
};

export const updateMyAccount = async (
  updateMyAccountBody: UpdateMyAccountBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getUpdateMyAccountUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMyAccountBody),
  });
};

export const getUpdateMyAccountMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyAccount>>,
    TError,
    { data: BodyType<UpdateMyAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyAccount>>,
  TError,
  { data: BodyType<UpdateMyAccountBody> },
  TContext
> => {
  const mutationKey = ["updateMyAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyAccount>>,
    { data: BodyType<UpdateMyAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyAccount>>
>;
export type UpdateMyAccountMutationBody = BodyType<UpdateMyAccountBody>;
export type UpdateMyAccountMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the signed-in player's name or phone
 */
export const useUpdateMyAccount = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyAccount>>,
    TError,
    { data: BodyType<UpdateMyAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyAccount>>,
  TError,
  { data: BodyType<UpdateMyAccountBody> },
  TContext
> => {
  return useMutation(getUpdateMyAccountMutationOptions(options));
};

/**
 * @summary Get the currently signed-in player
 */
export const getGetPlayerMeUrl = () => {
  return `/api/player-auth/me`;
};

export const getPlayerMe = async (options?: RequestInit): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getGetPlayerMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlayerMeQueryKey = () => {
  return [`/api/player-auth/me`] as const;
};

export const getGetPlayerMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlayerMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlayerMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlayerMe>>> = ({
    signal,
  }) => getPlayerMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlayerMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlayerMe>>
>;
export type GetPlayerMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the currently signed-in player
 */

export function useGetPlayerMe<
  TData = Awaited<ReturnType<typeof getPlayerMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlayerMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlayerMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Public. Always returns 200 with a generic message regardless of whether
the email is on file, to avoid leaking which staff addresses exist.
Throttled per IP and per email.

 * @summary Email a one-time link to reset a staff password
 */
export const getRequestStaffPasswordResetUrl = () => {
  return `/api/auth/forgot-password`;
};

export const requestStaffPasswordReset = async (
  staffRequestPasswordResetBody: StaffRequestPasswordResetBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRequestStaffPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(staffRequestPasswordResetBody),
  });
};

export const getRequestStaffPasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestStaffPasswordReset>>,
    TError,
    { data: BodyType<StaffRequestPasswordResetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestStaffPasswordReset>>,
  TError,
  { data: BodyType<StaffRequestPasswordResetBody> },
  TContext
> => {
  const mutationKey = ["requestStaffPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestStaffPasswordReset>>,
    { data: BodyType<StaffRequestPasswordResetBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestStaffPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestStaffPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestStaffPasswordReset>>
>;
export type RequestStaffPasswordResetMutationBody =
  BodyType<StaffRequestPasswordResetBody>;
export type RequestStaffPasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Email a one-time link to reset a staff password
 */
export const useRequestStaffPasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestStaffPasswordReset>>,
    TError,
    { data: BodyType<StaffRequestPasswordResetBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestStaffPasswordReset>>,
  TError,
  { data: BodyType<StaffRequestPasswordResetBody> },
  TContext
> => {
  return useMutation(getRequestStaffPasswordResetMutationOptions(options));
};

/**
 * Public. The token travels in the request body.
 * @summary Look up a staff password-reset token
 */
export const getLookupStaffPasswordResetUrl = () => {
  return `/api/auth/reset-lookup`;
};

export const lookupStaffPasswordReset = async (
  lookupInviteBody: LookupInviteBody,
  options?: RequestInit,
): Promise<InviteInfo> => {
  return customFetch<InviteInfo>(getLookupStaffPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(lookupInviteBody),
  });
};

export const getLookupStaffPasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupStaffPasswordReset>>,
    TError,
    { data: BodyType<LookupInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupStaffPasswordReset>>,
  TError,
  { data: BodyType<LookupInviteBody> },
  TContext
> => {
  const mutationKey = ["lookupStaffPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupStaffPasswordReset>>,
    { data: BodyType<LookupInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return lookupStaffPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupStaffPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupStaffPasswordReset>>
>;
export type LookupStaffPasswordResetMutationBody = BodyType<LookupInviteBody>;
export type LookupStaffPasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Look up a staff password-reset token
 */
export const useLookupStaffPasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupStaffPasswordReset>>,
    TError,
    { data: BodyType<LookupInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lookupStaffPasswordReset>>,
  TError,
  { data: BodyType<LookupInviteBody> },
  TContext
> => {
  return useMutation(getLookupStaffPasswordResetMutationOptions(options));
};

/**
 * Public. Single-use; the token is sent in the request body so it is not
captured by URL-based access logs. Setting a new password invalidates
every existing session for the staff member, then signs them in fresh.

 * @summary Redeem a staff password-reset token by setting a new password
 */
export const getAcceptStaffPasswordResetUrl = () => {
  return `/api/auth/reset-accept`;
};

export const acceptStaffPasswordReset = async (
  acceptInviteBody: AcceptInviteBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAcceptStaffPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptInviteBody),
  });
};

export const getAcceptStaffPasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptStaffPasswordReset>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptStaffPasswordReset>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  const mutationKey = ["acceptStaffPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptStaffPasswordReset>>,
    { data: BodyType<AcceptInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptStaffPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptStaffPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptStaffPasswordReset>>
>;
export type AcceptStaffPasswordResetMutationBody = BodyType<AcceptInviteBody>;
export type AcceptStaffPasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Redeem a staff password-reset token by setting a new password
 */
export const useAcceptStaffPasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptStaffPasswordReset>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptStaffPasswordReset>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  return useMutation(getAcceptStaffPasswordResetMutationOptions(options));
};

/**
 * Public. Always returns 200 with a generic message regardless of whether
the email is on file, to avoid leaking which addresses exist.

 * @summary Email a one-time link to set or reset a player password
 */
export const getRequestPlayerPasswordSetupUrl = () => {
  return `/api/player-auth/request-password-setup`;
};

export const requestPlayerPasswordSetup = async (
  playerRequestPasswordSetupBody: PlayerRequestPasswordSetupBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRequestPlayerPasswordSetupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(playerRequestPasswordSetupBody),
  });
};

export const getRequestPlayerPasswordSetupMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPlayerPasswordSetup>>,
    TError,
    { data: BodyType<PlayerRequestPasswordSetupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPlayerPasswordSetup>>,
  TError,
  { data: BodyType<PlayerRequestPasswordSetupBody> },
  TContext
> => {
  const mutationKey = ["requestPlayerPasswordSetup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPlayerPasswordSetup>>,
    { data: BodyType<PlayerRequestPasswordSetupBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestPlayerPasswordSetup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPlayerPasswordSetupMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPlayerPasswordSetup>>
>;
export type RequestPlayerPasswordSetupMutationBody =
  BodyType<PlayerRequestPasswordSetupBody>;
export type RequestPlayerPasswordSetupMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Email a one-time link to set or reset a player password
 */
export const useRequestPlayerPasswordSetup = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPlayerPasswordSetup>>,
    TError,
    { data: BodyType<PlayerRequestPasswordSetupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestPlayerPasswordSetup>>,
  TError,
  { data: BodyType<PlayerRequestPasswordSetupBody> },
  TContext
> => {
  return useMutation(getRequestPlayerPasswordSetupMutationOptions(options));
};

/**
 * Public. The token travels in the request body.
 * @summary Look up a password setup token
 */
export const getLookupPlayerPasswordResetUrl = () => {
  return `/api/player-auth/reset-lookup`;
};

export const lookupPlayerPasswordReset = async (
  lookupInviteBody: LookupInviteBody,
  options?: RequestInit,
): Promise<InviteInfo> => {
  return customFetch<InviteInfo>(getLookupPlayerPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(lookupInviteBody),
  });
};

export const getLookupPlayerPasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupPlayerPasswordReset>>,
    TError,
    { data: BodyType<LookupInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupPlayerPasswordReset>>,
  TError,
  { data: BodyType<LookupInviteBody> },
  TContext
> => {
  const mutationKey = ["lookupPlayerPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupPlayerPasswordReset>>,
    { data: BodyType<LookupInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return lookupPlayerPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupPlayerPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupPlayerPasswordReset>>
>;
export type LookupPlayerPasswordResetMutationBody = BodyType<LookupInviteBody>;
export type LookupPlayerPasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Look up a password setup token
 */
export const useLookupPlayerPasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupPlayerPasswordReset>>,
    TError,
    { data: BodyType<LookupInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lookupPlayerPasswordReset>>,
  TError,
  { data: BodyType<LookupInviteBody> },
  TContext
> => {
  return useMutation(getLookupPlayerPasswordResetMutationOptions(options));
};

/**
 * @summary Redeem a password setup token by setting a password
 */
export const getAcceptPlayerPasswordResetUrl = () => {
  return `/api/player-auth/reset-accept`;
};

export const acceptPlayerPasswordReset = async (
  acceptInviteBody: AcceptInviteBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getAcceptPlayerPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptInviteBody),
  });
};

export const getAcceptPlayerPasswordResetMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptPlayerPasswordReset>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptPlayerPasswordReset>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  const mutationKey = ["acceptPlayerPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptPlayerPasswordReset>>,
    { data: BodyType<AcceptInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptPlayerPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptPlayerPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptPlayerPasswordReset>>
>;
export type AcceptPlayerPasswordResetMutationBody = BodyType<AcceptInviteBody>;
export type AcceptPlayerPasswordResetMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Redeem a password setup token by setting a password
 */
export const useAcceptPlayerPasswordReset = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptPlayerPasswordReset>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptPlayerPasswordReset>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  return useMutation(getAcceptPlayerPasswordResetMutationOptions(options));
};

/**
 * Public. The token travels in the request body — never in the URL — so it
is not captured by URL-based access logs.

 * @summary Look up an invite by its token
 */
export const getLookupInviteUrl = () => {
  return `/api/invites/lookup`;
};

export const lookupInvite = async (
  lookupInviteBody: LookupInviteBody,
  options?: RequestInit,
): Promise<InviteInfo> => {
  return customFetch<InviteInfo>(getLookupInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(lookupInviteBody),
  });
};

export const getLookupInviteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupInvite>>,
    TError,
    { data: BodyType<LookupInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupInvite>>,
  TError,
  { data: BodyType<LookupInviteBody> },
  TContext
> => {
  const mutationKey = ["lookupInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupInvite>>,
    { data: BodyType<LookupInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return lookupInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupInvite>>
>;
export type LookupInviteMutationBody = BodyType<LookupInviteBody>;
export type LookupInviteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Look up an invite by its token
 */
export const useLookupInvite = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupInvite>>,
    TError,
    { data: BodyType<LookupInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lookupInvite>>,
  TError,
  { data: BodyType<LookupInviteBody> },
  TContext
> => {
  return useMutation(getLookupInviteMutationOptions(options));
};

/**
 * Public. Single-use; the token is sent in the request body so it is not
captured by URL-based access logs.

 * @summary Redeem an invite token by setting a password
 */
export const getAcceptInviteUrl = () => {
  return `/api/invites/accept`;
};

export const acceptInvite = async (
  acceptInviteBody: AcceptInviteBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAcceptInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptInviteBody),
  });
};

export const getAcceptInviteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  const mutationKey = ["acceptInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvite>>,
    { data: BodyType<AcceptInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvite>>
>;
export type AcceptInviteMutationBody = BodyType<AcceptInviteBody>;
export type AcceptInviteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Redeem an invite token by setting a password
 */
export const useAcceptInvite = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  return useMutation(getAcceptInviteMutationOptions(options));
};

/**
 * @summary Set or change a staff member's password
 */
export const getSetStaffPasswordUrl = (id: number) => {
  return `/api/staff/${id}/password`;
};

export const setStaffPassword = async (
  id: number,
  setStaffPasswordBody: SetStaffPasswordBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getSetStaffPasswordUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setStaffPasswordBody),
  });
};

export const getSetStaffPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStaffPassword>>,
    TError,
    { id: number; data: BodyType<SetStaffPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setStaffPassword>>,
  TError,
  { id: number; data: BodyType<SetStaffPasswordBody> },
  TContext
> => {
  const mutationKey = ["setStaffPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setStaffPassword>>,
    { id: number; data: BodyType<SetStaffPasswordBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setStaffPassword(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetStaffPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof setStaffPassword>>
>;
export type SetStaffPasswordMutationBody = BodyType<SetStaffPasswordBody>;
export type SetStaffPasswordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Set or change a staff member's password
 */
export const useSetStaffPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setStaffPassword>>,
    TError,
    { id: number; data: BodyType<SetStaffPasswordBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setStaffPassword>>,
  TError,
  { id: number; data: BodyType<SetStaffPasswordBody> },
  TContext
> => {
  return useMutation(getSetStaffPasswordMutationOptions(options));
};

/**
 * @summary List staff at a venue
 */
export const getGetVenueStaffUrl = (id: number) => {
  return `/api/venues/${id}/staff`;
};

export const getVenueStaff = async (
  id: number,
  options?: RequestInit,
): Promise<StaffMember[]> => {
  return customFetch<StaffMember[]>(getGetVenueStaffUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVenueStaffQueryKey = (id: number) => {
  return [`/api/venues/${id}/staff`] as const;
};

export const getGetVenueStaffQueryOptions = <
  TData = Awaited<ReturnType<typeof getVenueStaff>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenueStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVenueStaffQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenueStaff>>> = ({
    signal,
  }) => getVenueStaff(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVenueStaff>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVenueStaffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVenueStaff>>
>;
export type GetVenueStaffQueryError = ErrorType<unknown>;

/**
 * @summary List staff at a venue
 */

export function useGetVenueStaff<
  TData = Awaited<ReturnType<typeof getVenueStaff>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVenueStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVenueStaffQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Assign a staff member to a venue
 */
export const getAssignStaffToVenueUrl = (id: number) => {
  return `/api/venues/${id}/staff`;
};

export const assignStaffToVenue = async (
  id: number,
  assignStaffBody: AssignStaffBody,
  options?: RequestInit,
): Promise<StaffMember> => {
  return customFetch<StaffMember>(getAssignStaffToVenueUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignStaffBody),
  });
};

export const getAssignStaffToVenueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignStaffToVenue>>,
    TError,
    { id: number; data: BodyType<AssignStaffBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignStaffToVenue>>,
  TError,
  { id: number; data: BodyType<AssignStaffBody> },
  TContext
> => {
  const mutationKey = ["assignStaffToVenue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignStaffToVenue>>,
    { id: number; data: BodyType<AssignStaffBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignStaffToVenue(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignStaffToVenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignStaffToVenue>>
>;
export type AssignStaffToVenueMutationBody = BodyType<AssignStaffBody>;
export type AssignStaffToVenueMutationError = ErrorType<unknown>;

/**
 * @summary Assign a staff member to a venue
 */
export const useAssignStaffToVenue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignStaffToVenue>>,
    TError,
    { id: number; data: BodyType<AssignStaffBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignStaffToVenue>>,
  TError,
  { id: number; data: BodyType<AssignStaffBody> },
  TContext
> => {
  return useMutation(getAssignStaffToVenueMutationOptions(options));
};

/**
 * @summary Remove a staff member from a venue
 */
export const getRemoveStaffFromVenueUrl = (id: number, staffId: number) => {
  return `/api/venues/${id}/staff/${staffId}`;
};

export const removeStaffFromVenue = async (
  id: number,
  staffId: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getRemoveStaffFromVenueUrl(id, staffId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveStaffFromVenueMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStaffFromVenue>>,
    TError,
    { id: number; staffId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeStaffFromVenue>>,
  TError,
  { id: number; staffId: number },
  TContext
> => {
  const mutationKey = ["removeStaffFromVenue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeStaffFromVenue>>,
    { id: number; staffId: number }
  > = (props) => {
    const { id, staffId } = props ?? {};

    return removeStaffFromVenue(id, staffId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveStaffFromVenueMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeStaffFromVenue>>
>;

export type RemoveStaffFromVenueMutationError = ErrorType<unknown>;

/**
 * @summary Remove a staff member from a venue
 */
export const useRemoveStaffFromVenue = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeStaffFromVenue>>,
    TError,
    { id: number; staffId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeStaffFromVenue>>,
  TError,
  { id: number; staffId: number },
  TContext
> => {
  return useMutation(getRemoveStaffFromVenueMutationOptions(options));
};

/**
 * @summary List all blind structures
 */
export const getListBlindStructuresUrl = () => {
  return `/api/blind-structures`;
};

export const listBlindStructures = async (
  options?: RequestInit,
): Promise<BlindStructure[]> => {
  return customFetch<BlindStructure[]>(getListBlindStructuresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListBlindStructuresQueryKey = () => {
  return [`/api/blind-structures`] as const;
};

export const getListBlindStructuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listBlindStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBlindStructures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBlindStructuresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBlindStructures>>
  > = ({ signal }) => listBlindStructures({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBlindStructures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBlindStructuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBlindStructures>>
>;
export type ListBlindStructuresQueryError = ErrorType<unknown>;

/**
 * @summary List all blind structures
 */

export function useListBlindStructures<
  TData = Awaited<ReturnType<typeof listBlindStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listBlindStructures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBlindStructuresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a blind structure
 */
export const getCreateBlindStructureUrl = () => {
  return `/api/blind-structures`;
};

export const createBlindStructure = async (
  createBlindStructureBody: CreateBlindStructureBody,
  options?: RequestInit,
): Promise<BlindStructure> => {
  return customFetch<BlindStructure>(getCreateBlindStructureUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBlindStructureBody),
  });
};

export const getCreateBlindStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBlindStructure>>,
    TError,
    { data: BodyType<CreateBlindStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBlindStructure>>,
  TError,
  { data: BodyType<CreateBlindStructureBody> },
  TContext
> => {
  const mutationKey = ["createBlindStructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBlindStructure>>,
    { data: BodyType<CreateBlindStructureBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBlindStructure(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBlindStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBlindStructure>>
>;
export type CreateBlindStructureMutationBody =
  BodyType<CreateBlindStructureBody>;
export type CreateBlindStructureMutationError = ErrorType<unknown>;

/**
 * @summary Create a blind structure
 */
export const useCreateBlindStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBlindStructure>>,
    TError,
    { data: BodyType<CreateBlindStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBlindStructure>>,
  TError,
  { data: BodyType<CreateBlindStructureBody> },
  TContext
> => {
  return useMutation(getCreateBlindStructureMutationOptions(options));
};

/**
 * @summary Get a blind structure with levels
 */
export const getGetBlindStructureUrl = (id: number) => {
  return `/api/blind-structures/${id}`;
};

export const getBlindStructure = async (
  id: number,
  options?: RequestInit,
): Promise<BlindStructure> => {
  return customFetch<BlindStructure>(getGetBlindStructureUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetBlindStructureQueryKey = (id: number) => {
  return [`/api/blind-structures/${id}`] as const;
};

export const getGetBlindStructureQueryOptions = <
  TData = Awaited<ReturnType<typeof getBlindStructure>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBlindStructure>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBlindStructureQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBlindStructure>>
  > = ({ signal }) => getBlindStructure(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBlindStructure>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBlindStructureQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBlindStructure>>
>;
export type GetBlindStructureQueryError = ErrorType<unknown>;

/**
 * @summary Get a blind structure with levels
 */

export function useGetBlindStructure<
  TData = Awaited<ReturnType<typeof getBlindStructure>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBlindStructure>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBlindStructureQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a blind structure
 */
export const getUpdateBlindStructureUrl = (id: number) => {
  return `/api/blind-structures/${id}`;
};

export const updateBlindStructure = async (
  id: number,
  updateBlindStructureBody: UpdateBlindStructureBody,
  options?: RequestInit,
): Promise<BlindStructure> => {
  return customFetch<BlindStructure>(getUpdateBlindStructureUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBlindStructureBody),
  });
};

export const getUpdateBlindStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBlindStructure>>,
    TError,
    { id: number; data: BodyType<UpdateBlindStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBlindStructure>>,
  TError,
  { id: number; data: BodyType<UpdateBlindStructureBody> },
  TContext
> => {
  const mutationKey = ["updateBlindStructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBlindStructure>>,
    { id: number; data: BodyType<UpdateBlindStructureBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBlindStructure(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBlindStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBlindStructure>>
>;
export type UpdateBlindStructureMutationBody =
  BodyType<UpdateBlindStructureBody>;
export type UpdateBlindStructureMutationError = ErrorType<unknown>;

/**
 * @summary Update a blind structure
 */
export const useUpdateBlindStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBlindStructure>>,
    TError,
    { id: number; data: BodyType<UpdateBlindStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBlindStructure>>,
  TError,
  { id: number; data: BodyType<UpdateBlindStructureBody> },
  TContext
> => {
  return useMutation(getUpdateBlindStructureMutationOptions(options));
};

/**
 * @summary Delete a blind structure
 */
export const getDeleteBlindStructureUrl = (id: number) => {
  return `/api/blind-structures/${id}`;
};

export const deleteBlindStructure = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteBlindStructureUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBlindStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlindStructure>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBlindStructure>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteBlindStructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBlindStructure>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBlindStructure(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBlindStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBlindStructure>>
>;

export type DeleteBlindStructureMutationError = ErrorType<unknown>;

/**
 * @summary Delete a blind structure
 */
export const useDeleteBlindStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBlindStructure>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBlindStructure>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteBlindStructureMutationOptions(options));
};

/**
 * @summary Replace all levels for a blind structure
 */
export const getSetBlindLevelsUrl = (id: number) => {
  return `/api/blind-structures/${id}/levels`;
};

export const setBlindLevels = async (
  id: number,
  setBlindLevelsBody: SetBlindLevelsBody,
  options?: RequestInit,
): Promise<BlindStructure> => {
  return customFetch<BlindStructure>(getSetBlindLevelsUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setBlindLevelsBody),
  });
};

export const getSetBlindLevelsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setBlindLevels>>,
    TError,
    { id: number; data: BodyType<SetBlindLevelsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setBlindLevels>>,
  TError,
  { id: number; data: BodyType<SetBlindLevelsBody> },
  TContext
> => {
  const mutationKey = ["setBlindLevels"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setBlindLevels>>,
    { id: number; data: BodyType<SetBlindLevelsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setBlindLevels(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetBlindLevelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setBlindLevels>>
>;
export type SetBlindLevelsMutationBody = BodyType<SetBlindLevelsBody>;
export type SetBlindLevelsMutationError = ErrorType<unknown>;

/**
 * @summary Replace all levels for a blind structure
 */
export const useSetBlindLevels = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setBlindLevels>>,
    TError,
    { id: number; data: BodyType<SetBlindLevelsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setBlindLevels>>,
  TError,
  { id: number; data: BodyType<SetBlindLevelsBody> },
  TContext
> => {
  return useMutation(getSetBlindLevelsMutationOptions(options));
};

/**
 * @summary List all payout structures
 */
export const getListPayoutStructuresUrl = () => {
  return `/api/payout-structures`;
};

export const listPayoutStructures = async (
  options?: RequestInit,
): Promise<PayoutStructure[]> => {
  return customFetch<PayoutStructure[]>(getListPayoutStructuresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPayoutStructuresQueryKey = () => {
  return [`/api/payout-structures`] as const;
};

export const getListPayoutStructuresQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayoutStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPayoutStructures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPayoutStructuresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPayoutStructures>>
  > = ({ signal }) => listPayoutStructures({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayoutStructures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPayoutStructuresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPayoutStructures>>
>;
export type ListPayoutStructuresQueryError = ErrorType<unknown>;

/**
 * @summary List all payout structures
 */

export function useListPayoutStructures<
  TData = Awaited<ReturnType<typeof listPayoutStructures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPayoutStructures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPayoutStructuresQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a payout structure
 */
export const getCreatePayoutStructureUrl = () => {
  return `/api/payout-structures`;
};

export const createPayoutStructure = async (
  createPayoutStructureBody: CreatePayoutStructureBody,
  options?: RequestInit,
): Promise<PayoutStructure> => {
  return customFetch<PayoutStructure>(getCreatePayoutStructureUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPayoutStructureBody),
  });
};

export const getCreatePayoutStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayoutStructure>>,
    TError,
    { data: BodyType<CreatePayoutStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayoutStructure>>,
  TError,
  { data: BodyType<CreatePayoutStructureBody> },
  TContext
> => {
  const mutationKey = ["createPayoutStructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayoutStructure>>,
    { data: BodyType<CreatePayoutStructureBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPayoutStructure(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayoutStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayoutStructure>>
>;
export type CreatePayoutStructureMutationBody =
  BodyType<CreatePayoutStructureBody>;
export type CreatePayoutStructureMutationError = ErrorType<unknown>;

/**
 * @summary Create a payout structure
 */
export const useCreatePayoutStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayoutStructure>>,
    TError,
    { data: BodyType<CreatePayoutStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPayoutStructure>>,
  TError,
  { data: BodyType<CreatePayoutStructureBody> },
  TContext
> => {
  return useMutation(getCreatePayoutStructureMutationOptions(options));
};

/**
 * @summary Get a payout structure with tiers
 */
export const getGetPayoutStructureUrl = (id: number) => {
  return `/api/payout-structures/${id}`;
};

export const getPayoutStructure = async (
  id: number,
  options?: RequestInit,
): Promise<PayoutStructure> => {
  return customFetch<PayoutStructure>(getGetPayoutStructureUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPayoutStructureQueryKey = (id: number) => {
  return [`/api/payout-structures/${id}`] as const;
};

export const getGetPayoutStructureQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayoutStructure>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutStructure>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPayoutStructureQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPayoutStructure>>
  > = ({ signal }) => getPayoutStructure(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayoutStructure>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPayoutStructureQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPayoutStructure>>
>;
export type GetPayoutStructureQueryError = ErrorType<unknown>;

/**
 * @summary Get a payout structure with tiers
 */

export function useGetPayoutStructure<
  TData = Awaited<ReturnType<typeof getPayoutStructure>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPayoutStructure>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPayoutStructureQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a payout structure
 */
export const getUpdatePayoutStructureUrl = (id: number) => {
  return `/api/payout-structures/${id}`;
};

export const updatePayoutStructure = async (
  id: number,
  updatePayoutStructureBody: UpdatePayoutStructureBody,
  options?: RequestInit,
): Promise<PayoutStructure> => {
  return customFetch<PayoutStructure>(getUpdatePayoutStructureUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePayoutStructureBody),
  });
};

export const getUpdatePayoutStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePayoutStructure>>,
    TError,
    { id: number; data: BodyType<UpdatePayoutStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePayoutStructure>>,
  TError,
  { id: number; data: BodyType<UpdatePayoutStructureBody> },
  TContext
> => {
  const mutationKey = ["updatePayoutStructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePayoutStructure>>,
    { id: number; data: BodyType<UpdatePayoutStructureBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePayoutStructure(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePayoutStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePayoutStructure>>
>;
export type UpdatePayoutStructureMutationBody =
  BodyType<UpdatePayoutStructureBody>;
export type UpdatePayoutStructureMutationError = ErrorType<unknown>;

/**
 * @summary Update a payout structure
 */
export const useUpdatePayoutStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePayoutStructure>>,
    TError,
    { id: number; data: BodyType<UpdatePayoutStructureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePayoutStructure>>,
  TError,
  { id: number; data: BodyType<UpdatePayoutStructureBody> },
  TContext
> => {
  return useMutation(getUpdatePayoutStructureMutationOptions(options));
};

/**
 * @summary Delete a payout structure
 */
export const getDeletePayoutStructureUrl = (id: number) => {
  return `/api/payout-structures/${id}`;
};

export const deletePayoutStructure = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeletePayoutStructureUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePayoutStructureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePayoutStructure>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePayoutStructure>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePayoutStructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePayoutStructure>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePayoutStructure(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePayoutStructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePayoutStructure>>
>;

export type DeletePayoutStructureMutationError = ErrorType<unknown>;

/**
 * @summary Delete a payout structure
 */
export const useDeletePayoutStructure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePayoutStructure>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePayoutStructure>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeletePayoutStructureMutationOptions(options));
};

/**
 * @summary Replace all tiers for a payout structure
 */
export const getSetPayoutTiersUrl = (id: number) => {
  return `/api/payout-structures/${id}/tiers`;
};

export const setPayoutTiers = async (
  id: number,
  setPayoutTiersBody: SetPayoutTiersBody,
  options?: RequestInit,
): Promise<PayoutStructure> => {
  return customFetch<PayoutStructure>(getSetPayoutTiersUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setPayoutTiersBody),
  });
};

export const getSetPayoutTiersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPayoutTiers>>,
    TError,
    { id: number; data: BodyType<SetPayoutTiersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPayoutTiers>>,
  TError,
  { id: number; data: BodyType<SetPayoutTiersBody> },
  TContext
> => {
  const mutationKey = ["setPayoutTiers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPayoutTiers>>,
    { id: number; data: BodyType<SetPayoutTiersBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setPayoutTiers(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPayoutTiersMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPayoutTiers>>
>;
export type SetPayoutTiersMutationBody = BodyType<SetPayoutTiersBody>;
export type SetPayoutTiersMutationError = ErrorType<unknown>;

/**
 * @summary Replace all tiers for a payout structure
 */
export const useSetPayoutTiers = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPayoutTiers>>,
    TError,
    { id: number; data: BodyType<SetPayoutTiersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setPayoutTiers>>,
  TError,
  { id: number; data: BodyType<SetPayoutTiersBody> },
  TContext
> => {
  return useMutation(getSetPayoutTiersMutationOptions(options));
};

/**
 * @summary List all tournaments
 */
export const getListTournamentsUrl = (params?: ListTournamentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tournaments?${stringifiedParams}`
    : `/api/tournaments`;
};

export const listTournaments = async (
  params?: ListTournamentsParams,
  options?: RequestInit,
): Promise<PaginatedTournaments> => {
  return customFetch<PaginatedTournaments>(getListTournamentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTournamentsQueryKey = (params?: ListTournamentsParams) => {
  return [`/api/tournaments`, ...(params ? [params] : [])] as const;
};

export const getListTournamentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTournaments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTournamentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTournaments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTournamentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTournaments>>> = ({
    signal,
  }) => listTournaments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTournaments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTournamentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTournaments>>
>;
export type ListTournamentsQueryError = ErrorType<unknown>;

/**
 * @summary List all tournaments
 */

export function useListTournaments<
  TData = Awaited<ReturnType<typeof listTournaments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTournamentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTournaments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTournamentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a tournament
 */
export const getCreateTournamentUrl = () => {
  return `/api/tournaments`;
};

export const createTournament = async (
  createTournamentBody: CreateTournamentBody,
  options?: RequestInit,
): Promise<Tournament> => {
  return customFetch<Tournament>(getCreateTournamentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTournamentBody),
  });
};

export const getCreateTournamentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTournament>>,
    TError,
    { data: BodyType<CreateTournamentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTournament>>,
  TError,
  { data: BodyType<CreateTournamentBody> },
  TContext
> => {
  const mutationKey = ["createTournament"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTournament>>,
    { data: BodyType<CreateTournamentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTournament(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTournamentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTournament>>
>;
export type CreateTournamentMutationBody = BodyType<CreateTournamentBody>;
export type CreateTournamentMutationError = ErrorType<unknown>;

/**
 * @summary Create a tournament
 */
export const useCreateTournament = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTournament>>,
    TError,
    { data: BodyType<CreateTournamentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTournament>>,
  TError,
  { data: BodyType<CreateTournamentBody> },
  TContext
> => {
  return useMutation(getCreateTournamentMutationOptions(options));
};

/**
 * @summary Get a tournament
 */
export const getGetTournamentUrl = (id: number) => {
  return `/api/tournaments/${id}`;
};

export const getTournament = async (
  id: number,
  options?: RequestInit,
): Promise<Tournament> => {
  return customFetch<Tournament>(getGetTournamentUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTournamentQueryKey = (id: number) => {
  return [`/api/tournaments/${id}`] as const;
};

export const getGetTournamentQueryOptions = <
  TData = Awaited<ReturnType<typeof getTournament>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournament>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTournamentQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTournament>>> = ({
    signal,
  }) => getTournament(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTournament>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTournamentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTournament>>
>;
export type GetTournamentQueryError = ErrorType<unknown>;

/**
 * @summary Get a tournament
 */

export function useGetTournament<
  TData = Awaited<ReturnType<typeof getTournament>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournament>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTournamentQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a tournament
 */
export const getUpdateTournamentUrl = (id: number) => {
  return `/api/tournaments/${id}`;
};

export const updateTournament = async (
  id: number,
  updateTournamentBody: UpdateTournamentBody,
  options?: RequestInit,
): Promise<Tournament> => {
  return customFetch<Tournament>(getUpdateTournamentUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTournamentBody),
  });
};

export const getUpdateTournamentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTournament>>,
    TError,
    { id: number; data: BodyType<UpdateTournamentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTournament>>,
  TError,
  { id: number; data: BodyType<UpdateTournamentBody> },
  TContext
> => {
  const mutationKey = ["updateTournament"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTournament>>,
    { id: number; data: BodyType<UpdateTournamentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTournament(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTournamentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTournament>>
>;
export type UpdateTournamentMutationBody = BodyType<UpdateTournamentBody>;
export type UpdateTournamentMutationError = ErrorType<unknown>;

/**
 * @summary Update a tournament
 */
export const useUpdateTournament = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTournament>>,
    TError,
    { id: number; data: BodyType<UpdateTournamentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTournament>>,
  TError,
  { id: number; data: BodyType<UpdateTournamentBody> },
  TContext
> => {
  return useMutation(getUpdateTournamentMutationOptions(options));
};

/**
 * @summary Delete a tournament
 */
export const getDeleteTournamentUrl = (id: number) => {
  return `/api/tournaments/${id}`;
};

export const deleteTournament = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteTournamentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTournamentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTournament>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTournament>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteTournament"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTournament>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTournament(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTournamentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTournament>>
>;

export type DeleteTournamentMutationError = ErrorType<unknown>;

/**
 * @summary Delete a tournament
 */
export const useDeleteTournament = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTournament>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTournament>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteTournamentMutationOptions(options));
};

/**
 * @summary Get results for a tournament
 */
export const getGetTournamentResultsUrl = (id: number) => {
  return `/api/tournaments/${id}/results`;
};

export const getTournamentResults = async (
  id: number,
  options?: RequestInit,
): Promise<ResultWithPlayer[]> => {
  return customFetch<ResultWithPlayer[]>(getGetTournamentResultsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTournamentResultsQueryKey = (id: number) => {
  return [`/api/tournaments/${id}/results`] as const;
};

export const getGetTournamentResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTournamentResults>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentResults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTournamentResultsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTournamentResults>>
  > = ({ signal }) => getTournamentResults(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTournamentResults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTournamentResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTournamentResults>>
>;
export type GetTournamentResultsQueryError = ErrorType<unknown>;

/**
 * @summary Get results for a tournament
 */

export function useGetTournamentResults<
  TData = Awaited<ReturnType<typeof getTournamentResults>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentResults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTournamentResultsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all results
 */
export const getListResultsUrl = (params?: ListResultsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/results?${stringifiedParams}`
    : `/api/results`;
};

export const listResults = async (
  params?: ListResultsParams,
  options?: RequestInit,
): Promise<PaginatedResults> => {
  return customFetch<PaginatedResults>(getListResultsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListResultsQueryKey = (params?: ListResultsParams) => {
  return [`/api/results`, ...(params ? [params] : [])] as const;
};

export const getListResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof listResults>>,
  TError = ErrorType<unknown>,
>(
  params?: ListResultsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListResultsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listResults>>> = ({
    signal,
  }) => listResults(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listResults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listResults>>
>;
export type ListResultsQueryError = ErrorType<unknown>;

/**
 * @summary List all results
 */

export function useListResults<
  TData = Awaited<ReturnType<typeof listResults>>,
  TError = ErrorType<unknown>,
>(
  params?: ListResultsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listResults>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListResultsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a result
 */
export const getCreateResultUrl = () => {
  return `/api/results`;
};

export const createResult = async (
  createResultBody: CreateResultBody,
  options?: RequestInit,
): Promise<Result> => {
  return customFetch<Result>(getCreateResultUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createResultBody),
  });
};

export const getCreateResultMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResult>>,
    TError,
    { data: BodyType<CreateResultBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createResult>>,
  TError,
  { data: BodyType<CreateResultBody> },
  TContext
> => {
  const mutationKey = ["createResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createResult>>,
    { data: BodyType<CreateResultBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createResult(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof createResult>>
>;
export type CreateResultMutationBody = BodyType<CreateResultBody>;
export type CreateResultMutationError = ErrorType<unknown>;

/**
 * @summary Create a result
 */
export const useCreateResult = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createResult>>,
    TError,
    { data: BodyType<CreateResultBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createResult>>,
  TError,
  { data: BodyType<CreateResultBody> },
  TContext
> => {
  return useMutation(getCreateResultMutationOptions(options));
};

/**
 * @summary Update a result
 */
export const getUpdateResultUrl = (id: number) => {
  return `/api/results/${id}`;
};

export const updateResult = async (
  id: number,
  updateResultBody: UpdateResultBody,
  options?: RequestInit,
): Promise<Result> => {
  return customFetch<Result>(getUpdateResultUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateResultBody),
  });
};

export const getUpdateResultMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResult>>,
    TError,
    { id: number; data: BodyType<UpdateResultBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateResult>>,
  TError,
  { id: number; data: BodyType<UpdateResultBody> },
  TContext
> => {
  const mutationKey = ["updateResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateResult>>,
    { id: number; data: BodyType<UpdateResultBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateResult(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateResult>>
>;
export type UpdateResultMutationBody = BodyType<UpdateResultBody>;
export type UpdateResultMutationError = ErrorType<unknown>;

/**
 * @summary Update a result
 */
export const useUpdateResult = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateResult>>,
    TError,
    { id: number; data: BodyType<UpdateResultBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateResult>>,
  TError,
  { id: number; data: BodyType<UpdateResultBody> },
  TContext
> => {
  return useMutation(getUpdateResultMutationOptions(options));
};

/**
 * @summary Delete a result
 */
export const getDeleteResultUrl = (id: number) => {
  return `/api/results/${id}`;
};

export const deleteResult = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteResultUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteResultMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteResult>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteResult>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteResult>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteResult(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteResult>>
>;

export type DeleteResultMutationError = ErrorType<unknown>;

/**
 * @summary Delete a result
 */
export const useDeleteResult = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteResult>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteResult>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteResultMutationOptions(options));
};

/**
 * @summary Players who used to attend regularly but have since stopped
 */
export const getGetLapsedRegularsUrl = (params?: GetLapsedRegularsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/lapsed-regulars?${stringifiedParams}`
    : `/api/dashboard/lapsed-regulars`;
};

export const getLapsedRegulars = async (
  params?: GetLapsedRegularsParams,
  options?: RequestInit,
): Promise<GetLapsedRegulars200> => {
  return customFetch<GetLapsedRegulars200>(getGetLapsedRegularsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLapsedRegularsQueryKey = (
  params?: GetLapsedRegularsParams,
) => {
  return [
    `/api/dashboard/lapsed-regulars`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetLapsedRegularsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLapsedRegulars>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLapsedRegularsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLapsedRegulars>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLapsedRegularsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLapsedRegulars>>
  > = ({ signal }) => getLapsedRegulars(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLapsedRegulars>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLapsedRegularsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLapsedRegulars>>
>;
export type GetLapsedRegularsQueryError = ErrorType<unknown>;

/**
 * @summary Players who used to attend regularly but have since stopped
 */

export function useGetLapsedRegulars<
  TData = Awaited<ReturnType<typeof getLapsedRegulars>>,
  TError = ErrorType<unknown>,
>(
  params?: GetLapsedRegularsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLapsedRegulars>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLapsedRegularsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Email a "we miss you" nudge to one or more lapsed regulars (Owner only)
 */
export const getNudgeLapsedRegularsUrl = () => {
  return `/api/dashboard/lapsed-regulars/nudge`;
};

export const nudgeLapsedRegulars = async (
  nudgeLapsedRegularsBody: NudgeLapsedRegularsBody,
  options?: RequestInit,
): Promise<NudgeLapsedRegularsResponse> => {
  return customFetch<NudgeLapsedRegularsResponse>(getNudgeLapsedRegularsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(nudgeLapsedRegularsBody),
  });
};

export const getNudgeLapsedRegularsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nudgeLapsedRegulars>>,
    TError,
    { data: BodyType<NudgeLapsedRegularsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof nudgeLapsedRegulars>>,
  TError,
  { data: BodyType<NudgeLapsedRegularsBody> },
  TContext
> => {
  const mutationKey = ["nudgeLapsedRegulars"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof nudgeLapsedRegulars>>,
    { data: BodyType<NudgeLapsedRegularsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return nudgeLapsedRegulars(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NudgeLapsedRegularsMutationResult = NonNullable<
  Awaited<ReturnType<typeof nudgeLapsedRegulars>>
>;
export type NudgeLapsedRegularsMutationBody = BodyType<NudgeLapsedRegularsBody>;
export type NudgeLapsedRegularsMutationError = ErrorType<unknown>;

/**
 * @summary Email a "we miss you" nudge to one or more lapsed regulars (Owner only)
 */
export const useNudgeLapsedRegulars = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nudgeLapsedRegulars>>,
    TError,
    { data: BodyType<NudgeLapsedRegularsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof nudgeLapsedRegulars>>,
  TError,
  { data: BodyType<NudgeLapsedRegularsBody> },
  TContext
> => {
  return useMutation(getNudgeLapsedRegularsMutationOptions(options));
};

/**
 * @summary Get dashboard overview stats
 */
export const getGetDashboardStatsUrl = () => {
  return `/api/dashboard/stats`;
};

export const getDashboardStats = async (
  options?: RequestInit,
): Promise<DashboardStats> => {
  return customFetch<DashboardStats>(getGetDashboardStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardStatsQueryKey = () => {
  return [`/api/dashboard/stats`] as const;
};

export const getGetDashboardStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardStats>>
  > = ({ signal }) => getDashboardStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardStats>>
>;
export type GetDashboardStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard overview stats
 */

export function useGetDashboardStats<
  TData = Awaited<ReturnType<typeof getDashboardStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List seasons for a league
 */
export const getListSeasonsUrl = (leagueId: number) => {
  return `/api/leagues/${leagueId}/seasons`;
};

export const listSeasons = async (
  leagueId: number,
  options?: RequestInit,
): Promise<Season[]> => {
  return customFetch<Season[]>(getListSeasonsUrl(leagueId), {
    ...options,
    method: "GET",
  });
};

export const getListSeasonsQueryKey = (leagueId: number) => {
  return [`/api/leagues/${leagueId}/seasons`] as const;
};

export const getListSeasonsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSeasons>>,
  TError = ErrorType<unknown>,
>(
  leagueId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSeasons>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSeasonsQueryKey(leagueId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSeasons>>> = ({
    signal,
  }) => listSeasons(leagueId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!leagueId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSeasons>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSeasonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSeasons>>
>;
export type ListSeasonsQueryError = ErrorType<unknown>;

/**
 * @summary List seasons for a league
 */

export function useListSeasons<
  TData = Awaited<ReturnType<typeof listSeasons>>,
  TError = ErrorType<unknown>,
>(
  leagueId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSeasons>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSeasonsQueryOptions(leagueId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a season for a league
 */
export const getCreateSeasonUrl = (leagueId: number) => {
  return `/api/leagues/${leagueId}/seasons`;
};

export const createSeason = async (
  leagueId: number,
  createSeasonBody: CreateSeasonBody,
  options?: RequestInit,
): Promise<Season> => {
  return customFetch<Season>(getCreateSeasonUrl(leagueId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSeasonBody),
  });
};

export const getCreateSeasonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSeason>>,
    TError,
    { leagueId: number; data: BodyType<CreateSeasonBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSeason>>,
  TError,
  { leagueId: number; data: BodyType<CreateSeasonBody> },
  TContext
> => {
  const mutationKey = ["createSeason"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSeason>>,
    { leagueId: number; data: BodyType<CreateSeasonBody> }
  > = (props) => {
    const { leagueId, data } = props ?? {};

    return createSeason(leagueId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSeasonMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSeason>>
>;
export type CreateSeasonMutationBody = BodyType<CreateSeasonBody>;
export type CreateSeasonMutationError = ErrorType<unknown>;

/**
 * @summary Create a season for a league
 */
export const useCreateSeason = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSeason>>,
    TError,
    { leagueId: number; data: BodyType<CreateSeasonBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSeason>>,
  TError,
  { leagueId: number; data: BodyType<CreateSeasonBody> },
  TContext
> => {
  return useMutation(getCreateSeasonMutationOptions(options));
};

/**
 * @summary Update a season
 */
export const getUpdateSeasonUrl = (id: number) => {
  return `/api/seasons/${id}`;
};

export const updateSeason = async (
  id: number,
  updateSeasonBody: UpdateSeasonBody,
  options?: RequestInit,
): Promise<Season> => {
  return customFetch<Season>(getUpdateSeasonUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSeasonBody),
  });
};

export const getUpdateSeasonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSeason>>,
    TError,
    { id: number; data: BodyType<UpdateSeasonBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSeason>>,
  TError,
  { id: number; data: BodyType<UpdateSeasonBody> },
  TContext
> => {
  const mutationKey = ["updateSeason"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSeason>>,
    { id: number; data: BodyType<UpdateSeasonBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSeason(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSeasonMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSeason>>
>;
export type UpdateSeasonMutationBody = BodyType<UpdateSeasonBody>;
export type UpdateSeasonMutationError = ErrorType<unknown>;

/**
 * @summary Update a season
 */
export const useUpdateSeason = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSeason>>,
    TError,
    { id: number; data: BodyType<UpdateSeasonBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSeason>>,
  TError,
  { id: number; data: BodyType<UpdateSeasonBody> },
  TContext
> => {
  return useMutation(getUpdateSeasonMutationOptions(options));
};

/**
 * @summary Delete a season
 */
export const getDeleteSeasonUrl = (id: number) => {
  return `/api/seasons/${id}`;
};

export const deleteSeason = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteSeasonUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSeasonMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeason>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSeason>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSeason"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSeason>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSeason(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSeasonMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSeason>>
>;

export type DeleteSeasonMutationError = ErrorType<unknown>;

/**
 * @summary Delete a season
 */
export const useDeleteSeason = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSeason>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSeason>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSeasonMutationOptions(options));
};

/**
 * @summary Aggregated leaderboard across every league + venue (player site)
 */
export const getGetCircuitLeaderboardUrl = () => {
  return `/api/leaderboard/circuit`;
};

export const getCircuitLeaderboard = async (
  options?: RequestInit,
): Promise<CircuitLeaderboardEntry[]> => {
  return customFetch<CircuitLeaderboardEntry[]>(getGetCircuitLeaderboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCircuitLeaderboardQueryKey = () => {
  return [`/api/leaderboard/circuit`] as const;
};

export const getGetCircuitLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getCircuitLeaderboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCircuitLeaderboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCircuitLeaderboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCircuitLeaderboard>>
  > = ({ signal }) => getCircuitLeaderboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCircuitLeaderboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCircuitLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCircuitLeaderboard>>
>;
export type GetCircuitLeaderboardQueryError = ErrorType<unknown>;

/**
 * @summary Aggregated leaderboard across every league + venue (player site)
 */

export function useGetCircuitLeaderboard<
  TData = Awaited<ReturnType<typeof getCircuitLeaderboard>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCircuitLeaderboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCircuitLeaderboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get leaderboard for a league
 */
export const getGetLeaderboardUrl = (
  leagueId: number,
  params?: GetLeaderboardParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/leaderboard/${leagueId}?${stringifiedParams}`
    : `/api/leaderboard/${leagueId}`;
};

export const getLeaderboard = async (
  leagueId: number,
  params?: GetLeaderboardParams,
  options?: RequestInit,
): Promise<PaginatedLeaderboard> => {
  return customFetch<PaginatedLeaderboard>(
    getGetLeaderboardUrl(leagueId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLeaderboardQueryKey = (
  leagueId: number,
  params?: GetLeaderboardParams,
) => {
  return [`/api/leaderboard/${leagueId}`, ...(params ? [params] : [])] as const;
};

export const getGetLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<unknown>,
>(
  leagueId: number,
  params?: GetLeaderboardParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeaderboard>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLeaderboardQueryKey(leagueId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeaderboard>>> = ({
    signal,
  }) => getLeaderboard(leagueId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!leagueId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLeaderboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLeaderboard>>
>;
export type GetLeaderboardQueryError = ErrorType<unknown>;

/**
 * @summary Get leaderboard for a league
 */

export function useGetLeaderboard<
  TData = Awaited<ReturnType<typeof getLeaderboard>>,
  TError = ErrorType<unknown>,
>(
  leagueId: number,
  params?: GetLeaderboardParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLeaderboard>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLeaderboardQueryOptions(leagueId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List current rate-limit / throttle entries (Owner-only)
 */
export const getListLoginAttemptsUrl = () => {
  return `/api/login-attempts`;
};

export const listLoginAttempts = async (
  options?: RequestInit,
): Promise<ListLoginAttemptsResponse> => {
  return customFetch<ListLoginAttemptsResponse>(getListLoginAttemptsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListLoginAttemptsQueryKey = () => {
  return [`/api/login-attempts`] as const;
};

export const getListLoginAttemptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLoginAttempts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLoginAttempts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLoginAttemptsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listLoginAttempts>>
  > = ({ signal }) => listLoginAttempts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLoginAttempts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLoginAttemptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLoginAttempts>>
>;
export type ListLoginAttemptsQueryError = ErrorType<unknown>;

/**
 * @summary List current rate-limit / throttle entries (Owner-only)
 */

export function useListLoginAttempts<
  TData = Awaited<ReturnType<typeof listLoginAttempts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listLoginAttempts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLoginAttemptsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Clear a single throttle entry (unblocks the key)
 */
export const getClearLoginAttemptUrl = (id: number) => {
  return `/api/login-attempts/${id}`;
};

export const clearLoginAttempt = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getClearLoginAttemptUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getClearLoginAttemptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearLoginAttempt>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearLoginAttempt>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["clearLoginAttempt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearLoginAttempt>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return clearLoginAttempt(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearLoginAttemptMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearLoginAttempt>>
>;

export type ClearLoginAttemptMutationError = ErrorType<unknown>;

/**
 * @summary Clear a single throttle entry (unblocks the key)
 */
export const useClearLoginAttempt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearLoginAttempt>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearLoginAttempt>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getClearLoginAttemptMutationOptions(options));
};

/**
 * @summary Update the signed-in player's profile preferences
 */
export const getUpdateMyPlayerProfileUrl = () => {
  return `/api/players/me`;
};

export const updateMyPlayerProfile = async (
  updatePlayerProfileBody: UpdatePlayerProfileBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getUpdateMyPlayerProfileUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePlayerProfileBody),
  });
};

export const getUpdateMyPlayerProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyPlayerProfile>>,
    TError,
    { data: BodyType<UpdatePlayerProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyPlayerProfile>>,
  TError,
  { data: BodyType<UpdatePlayerProfileBody> },
  TContext
> => {
  const mutationKey = ["updateMyPlayerProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyPlayerProfile>>,
    { data: BodyType<UpdatePlayerProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyPlayerProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyPlayerProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyPlayerProfile>>
>;
export type UpdateMyPlayerProfileMutationBody =
  BodyType<UpdatePlayerProfileBody>;
export type UpdateMyPlayerProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the signed-in player's profile preferences
 */
export const useUpdateMyPlayerProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyPlayerProfile>>,
    TError,
    { data: BodyType<UpdatePlayerProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyPlayerProfile>>,
  TError,
  { data: BodyType<UpdatePlayerProfileBody> },
  TContext
> => {
  return useMutation(getUpdateMyPlayerProfileMutationOptions(options));
};

/**
 * @summary List the signed-in player's upcoming RSVPs
 */
export const getListMyRegistrationsUrl = () => {
  return `/api/players/me/registrations`;
};

export const listMyRegistrations = async (
  options?: RequestInit,
): Promise<MyRegistration[]> => {
  return customFetch<MyRegistration[]>(getListMyRegistrationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMyRegistrationsQueryKey = () => {
  return [`/api/players/me/registrations`] as const;
};

export const getListMyRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyRegistrations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyRegistrations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMyRegistrationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyRegistrations>>
  > = ({ signal }) => listMyRegistrations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyRegistrations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyRegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyRegistrations>>
>;
export type ListMyRegistrationsQueryError = ErrorType<unknown>;

/**
 * @summary List the signed-in player's upcoming RSVPs
 */

export function useListMyRegistrations<
  TData = Awaited<ReturnType<typeof listMyRegistrations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMyRegistrations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyRegistrationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List registered players for a tournament
 */
export const getListTournamentRegistrationsUrl = (id: number) => {
  return `/api/tournaments/${id}/registrations`;
};

export const listTournamentRegistrations = async (
  id: number,
  options?: RequestInit,
): Promise<RegisteredPlayer[]> => {
  return customFetch<RegisteredPlayer[]>(
    getListTournamentRegistrationsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTournamentRegistrationsQueryKey = (id: number) => {
  return [`/api/tournaments/${id}/registrations`] as const;
};

export const getListTournamentRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTournamentRegistrations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTournamentRegistrations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTournamentRegistrationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTournamentRegistrations>>
  > = ({ signal }) =>
    listTournamentRegistrations(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listTournamentRegistrations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTournamentRegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTournamentRegistrations>>
>;
export type ListTournamentRegistrationsQueryError = ErrorType<unknown>;

/**
 * @summary List registered players for a tournament
 */

export function useListTournamentRegistrations<
  TData = Awaited<ReturnType<typeof listTournamentRegistrations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTournamentRegistrations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTournamentRegistrationsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a player for a tournament (or restore a soft-deleted RSVP)
 */
export const getCreateTournamentRegistrationUrl = (id: number) => {
  return `/api/tournaments/${id}/registrations`;
};

export const createTournamentRegistration = async (
  id: number,
  createRegistrationBody: CreateRegistrationBody,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getCreateTournamentRegistrationUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRegistrationBody),
  });
};

export const getCreateTournamentRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTournamentRegistration>>,
    TError,
    { id: number; data: BodyType<CreateRegistrationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTournamentRegistration>>,
  TError,
  { id: number; data: BodyType<CreateRegistrationBody> },
  TContext
> => {
  const mutationKey = ["createTournamentRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTournamentRegistration>>,
    { id: number; data: BodyType<CreateRegistrationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createTournamentRegistration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTournamentRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTournamentRegistration>>
>;
export type CreateTournamentRegistrationMutationBody =
  BodyType<CreateRegistrationBody>;
export type CreateTournamentRegistrationMutationError = ErrorType<unknown>;

/**
 * @summary Register a player for a tournament (or restore a soft-deleted RSVP)
 */
export const useCreateTournamentRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTournamentRegistration>>,
    TError,
    { id: number; data: BodyType<CreateRegistrationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTournamentRegistration>>,
  TError,
  { id: number; data: BodyType<CreateRegistrationBody> },
  TContext
> => {
  return useMutation(getCreateTournamentRegistrationMutationOptions(options));
};

/**
 * @summary Create a Stripe Checkout session for a tournament buy-in
 */
export const getCreateStripeCheckoutSessionUrl = (id: number) => {
  return `/api/tournaments/${id}/registrations/checkout`;
};

export const createStripeCheckoutSession = async (
  id: number,
  createRegistrationBody?: CreateRegistrationBody,
  options?: RequestInit,
): Promise<StripeCheckoutResponse> => {
  return customFetch<StripeCheckoutResponse>(
    getCreateStripeCheckoutSessionUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createRegistrationBody),
    },
  );
};

export const getCreateStripeCheckoutSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripeCheckoutSession>>,
    TError,
    { id: number; data: BodyType<CreateRegistrationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStripeCheckoutSession>>,
  TError,
  { id: number; data: BodyType<CreateRegistrationBody> },
  TContext
> => {
  const mutationKey = ["createStripeCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStripeCheckoutSession>>,
    { id: number; data: BodyType<CreateRegistrationBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createStripeCheckoutSession(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStripeCheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStripeCheckoutSession>>
>;
export type CreateStripeCheckoutSessionMutationBody =
  BodyType<CreateRegistrationBody>;
export type CreateStripeCheckoutSessionMutationError = ErrorType<unknown>;

/**
 * @summary Create a Stripe Checkout session for a tournament buy-in
 */
export const useCreateStripeCheckoutSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripeCheckoutSession>>,
    TError,
    { id: number; data: BodyType<CreateRegistrationBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createStripeCheckoutSession>>,
  TError,
  { id: number; data: BodyType<CreateRegistrationBody> },
  TContext
> => {
  return useMutation(getCreateStripeCheckoutSessionMutationOptions(options));
};

/**
 * @summary Public Stripe publishable key (for client-side checks)
 */
export const getGetStripeConfigUrl = () => {
  return `/api/stripe/config`;
};

export const getStripeConfig = async (
  options?: RequestInit,
): Promise<GetStripeConfig200> => {
  return customFetch<GetStripeConfig200>(getGetStripeConfigUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetStripeConfigQueryKey = () => {
  return [`/api/stripe/config`] as const;
};

export const getGetStripeConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStripeConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStripeConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStripeConfig>>> = ({
    signal,
  }) => getStripeConfig({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStripeConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStripeConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStripeConfig>>
>;
export type GetStripeConfigQueryError = ErrorType<unknown>;

/**
 * @summary Public Stripe publishable key (for client-side checks)
 */

export function useGetStripeConfig<
  TData = Awaited<ReturnType<typeof getStripeConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getStripeConfig>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStripeConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Player self-cancel of their own RSVP
 */
export const getCancelMyRegistrationUrl = (id: number) => {
  return `/api/tournaments/${id}/registrations/me`;
};

export const cancelMyRegistration = async (
  id: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getCancelMyRegistrationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelMyRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMyRegistration>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMyRegistration>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["cancelMyRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMyRegistration>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return cancelMyRegistration(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMyRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMyRegistration>>
>;

export type CancelMyRegistrationMutationError = ErrorType<unknown>;

/**
 * @summary Player self-cancel of their own RSVP
 */
export const useCancelMyRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMyRegistration>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelMyRegistration>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getCancelMyRegistrationMutationOptions(options));
};

/**
 * @summary Cancel a registration (staff or player-self)
 */
export const getDeleteTournamentRegistrationUrl = (
  id: number,
  playerId: number,
) => {
  return `/api/tournaments/${id}/registrations/${playerId}`;
};

export const deleteTournamentRegistration = async (
  id: number,
  playerId: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getDeleteTournamentRegistrationUrl(id, playerId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteTournamentRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTournamentRegistration>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTournamentRegistration>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  const mutationKey = ["deleteTournamentRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTournamentRegistration>>,
    { id: number; playerId: number }
  > = (props) => {
    const { id, playerId } = props ?? {};

    return deleteTournamentRegistration(id, playerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTournamentRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTournamentRegistration>>
>;

export type DeleteTournamentRegistrationMutationError = ErrorType<unknown>;

/**
 * @summary Cancel a registration (staff or player-self)
 */
export const useDeleteTournamentRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTournamentRegistration>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTournamentRegistration>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  return useMutation(getDeleteTournamentRegistrationMutationOptions(options));
};

/**
 * @summary Promote a waitlisted registration to registered (staff only)
 */
export const getPromoteWaitlistRegistrationUrl = (
  id: number,
  playerId: number,
) => {
  return `/api/tournaments/${id}/registrations/${playerId}/promote`;
};

export const promoteWaitlistRegistration = async (
  id: number,
  playerId: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getPromoteWaitlistRegistrationUrl(id, playerId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPromoteWaitlistRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteWaitlistRegistration>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteWaitlistRegistration>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  const mutationKey = ["promoteWaitlistRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteWaitlistRegistration>>,
    { id: number; playerId: number }
  > = (props) => {
    const { id, playerId } = props ?? {};

    return promoteWaitlistRegistration(id, playerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteWaitlistRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteWaitlistRegistration>>
>;

export type PromoteWaitlistRegistrationMutationError = ErrorType<unknown>;

/**
 * @summary Promote a waitlisted registration to registered (staff only)
 */
export const usePromoteWaitlistRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteWaitlistRegistration>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoteWaitlistRegistration>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  return useMutation(getPromoteWaitlistRegistrationMutationOptions(options));
};

/**
 * @summary Demote an active registration back to the waitlist (staff only)
 */
export const getDemoteRegistrationToWaitlistUrl = (
  id: number,
  playerId: number,
) => {
  return `/api/tournaments/${id}/registrations/${playerId}/demote`;
};

export const demoteRegistrationToWaitlist = async (
  id: number,
  playerId: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getDemoteRegistrationToWaitlistUrl(id, playerId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDemoteRegistrationToWaitlistMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof demoteRegistrationToWaitlist>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof demoteRegistrationToWaitlist>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  const mutationKey = ["demoteRegistrationToWaitlist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof demoteRegistrationToWaitlist>>,
    { id: number; playerId: number }
  > = (props) => {
    const { id, playerId } = props ?? {};

    return demoteRegistrationToWaitlist(id, playerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DemoteRegistrationToWaitlistMutationResult = NonNullable<
  Awaited<ReturnType<typeof demoteRegistrationToWaitlist>>
>;

export type DemoteRegistrationToWaitlistMutationError = ErrorType<unknown>;

/**
 * @summary Demote an active registration back to the waitlist (staff only)
 */
export const useDemoteRegistrationToWaitlist = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof demoteRegistrationToWaitlist>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof demoteRegistrationToWaitlist>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  return useMutation(getDemoteRegistrationToWaitlistMutationOptions(options));
};

/**
 * @summary Reverse a no-show flag back to registered/late (staff only)
 */
export const getUndoRegistrationNoShowUrl = (id: number, playerId: number) => {
  return `/api/tournaments/${id}/registrations/${playerId}/undo-no-show`;
};

export const undoRegistrationNoShow = async (
  id: number,
  playerId: number,
  options?: RequestInit,
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(
    getUndoRegistrationNoShowUrl(id, playerId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getUndoRegistrationNoShowMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoRegistrationNoShow>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof undoRegistrationNoShow>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  const mutationKey = ["undoRegistrationNoShow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof undoRegistrationNoShow>>,
    { id: number; playerId: number }
  > = (props) => {
    const { id, playerId } = props ?? {};

    return undoRegistrationNoShow(id, playerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UndoRegistrationNoShowMutationResult = NonNullable<
  Awaited<ReturnType<typeof undoRegistrationNoShow>>
>;

export type UndoRegistrationNoShowMutationError = ErrorType<unknown>;

/**
 * @summary Reverse a no-show flag back to registered/late (staff only)
 */
export const useUndoRegistrationNoShow = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoRegistrationNoShow>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof undoRegistrationNoShow>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  return useMutation(getUndoRegistrationNoShowMutationOptions(options));
};

/**
 * @summary Refund a card-paid registration via Stripe (staff only)
 */
export const getRefundStripeRegistrationUrl = (
  id: number,
  playerId: number,
) => {
  return `/api/tournaments/${id}/registrations/${playerId}/refund`;
};

export const refundStripeRegistration = async (
  id: number,
  playerId: number,
  options?: RequestInit,
): Promise<RefundRegistrationResponse> => {
  return customFetch<RefundRegistrationResponse>(
    getRefundStripeRegistrationUrl(id, playerId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRefundStripeRegistrationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refundStripeRegistration>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refundStripeRegistration>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  const mutationKey = ["refundStripeRegistration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refundStripeRegistration>>,
    { id: number; playerId: number }
  > = (props) => {
    const { id, playerId } = props ?? {};

    return refundStripeRegistration(id, playerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefundStripeRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof refundStripeRegistration>>
>;

export type RefundStripeRegistrationMutationError = ErrorType<unknown>;

/**
 * @summary Refund a card-paid registration via Stripe (staff only)
 */
export const useRefundStripeRegistration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refundStripeRegistration>>,
    TError,
    { id: number; playerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refundStripeRegistration>>,
  TError,
  { id: number; playerId: number },
  TContext
> => {
  return useMutation(getRefundStripeRegistrationMutationOptions(options));
};

/**
 * @summary Adjust a registration's re-buy count by an integer delta
 */
export const getAdjustRegistrationRebuyUrl = (id: number, playerId: number) => {
  return `/api/tournaments/${id}/registrations/${playerId}/rebuy`;
};

export const adjustRegistrationRebuy = async (
  id: number,
  playerId: number,
  adjustRebuyBody: AdjustRebuyBody,
  options?: RequestInit,
): Promise<Registration> => {
  return customFetch<Registration>(
    getAdjustRegistrationRebuyUrl(id, playerId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adjustRebuyBody),
    },
  );
};

export const getAdjustRegistrationRebuyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustRegistrationRebuy>>,
    TError,
    { id: number; playerId: number; data: BodyType<AdjustRebuyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustRegistrationRebuy>>,
  TError,
  { id: number; playerId: number; data: BodyType<AdjustRebuyBody> },
  TContext
> => {
  const mutationKey = ["adjustRegistrationRebuy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustRegistrationRebuy>>,
    { id: number; playerId: number; data: BodyType<AdjustRebuyBody> }
  > = (props) => {
    const { id, playerId, data } = props ?? {};

    return adjustRegistrationRebuy(id, playerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustRegistrationRebuyMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustRegistrationRebuy>>
>;
export type AdjustRegistrationRebuyMutationBody = BodyType<AdjustRebuyBody>;
export type AdjustRegistrationRebuyMutationError = ErrorType<unknown>;

/**
 * @summary Adjust a registration's re-buy count by an integer delta
 */
export const useAdjustRegistrationRebuy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustRegistrationRebuy>>,
    TError,
    { id: number; playerId: number; data: BodyType<AdjustRebuyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adjustRegistrationRebuy>>,
  TError,
  { id: number; playerId: number; data: BodyType<AdjustRebuyBody> },
  TContext
> => {
  return useMutation(getAdjustRegistrationRebuyMutationOptions(options));
};

/**
 * @summary Record a knockout (auto-computes position / points / winnings)
 */
export const getCreateKnockoutResultUrl = () => {
  return `/api/results/knockout`;
};

export const createKnockoutResult = async (
  createKnockoutBody: CreateKnockoutBody,
  options?: RequestInit,
): Promise<Result> => {
  return customFetch<Result>(getCreateKnockoutResultUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createKnockoutBody),
  });
};

export const getCreateKnockoutResultMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKnockoutResult>>,
    TError,
    { data: BodyType<CreateKnockoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKnockoutResult>>,
  TError,
  { data: BodyType<CreateKnockoutBody> },
  TContext
> => {
  const mutationKey = ["createKnockoutResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKnockoutResult>>,
    { data: BodyType<CreateKnockoutBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createKnockoutResult(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKnockoutResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof createKnockoutResult>>
>;
export type CreateKnockoutResultMutationBody = BodyType<CreateKnockoutBody>;
export type CreateKnockoutResultMutationError = ErrorType<unknown>;

/**
 * @summary Record a knockout (auto-computes position / points / winnings)
 */
export const useCreateKnockoutResult = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKnockoutResult>>,
    TError,
    { data: BodyType<CreateKnockoutBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createKnockoutResult>>,
  TError,
  { data: BodyType<CreateKnockoutBody> },
  TContext
> => {
  return useMutation(getCreateKnockoutResultMutationOptions(options));
};

/**
 * @summary List cancelled RSVPs for a tournament (newest first, staff-only)
 */
export const getGetTournamentCancellationsUrl = (id: number) => {
  return `/api/tournaments/${id}/cancellations`;
};

export const getTournamentCancellations = async (
  id: number,
  options?: RequestInit,
): Promise<RegistrationCancellation[]> => {
  return customFetch<RegistrationCancellation[]>(
    getGetTournamentCancellationsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTournamentCancellationsQueryKey = (id: number) => {
  return [`/api/tournaments/${id}/cancellations`] as const;
};

export const getGetTournamentCancellationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTournamentCancellations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentCancellations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTournamentCancellationsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTournamentCancellations>>
  > = ({ signal }) =>
    getTournamentCancellations(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTournamentCancellations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTournamentCancellationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTournamentCancellations>>
>;
export type GetTournamentCancellationsQueryError = ErrorType<unknown>;

/**
 * @summary List cancelled RSVPs for a tournament (newest first, staff-only)
 */

export function useGetTournamentCancellations<
  TData = Awaited<ReturnType<typeof getTournamentCancellations>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentCancellations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTournamentCancellationsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List card refunds for a tournament (newest first, staff-only)
 */
export const getGetTournamentRefundsUrl = (id: number) => {
  return `/api/tournaments/${id}/refunds`;
};

export const getTournamentRefunds = async (
  id: number,
  options?: RequestInit,
): Promise<RegistrationRefund[]> => {
  return customFetch<RegistrationRefund[]>(getGetTournamentRefundsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTournamentRefundsQueryKey = (id: number) => {
  return [`/api/tournaments/${id}/refunds`] as const;
};

export const getGetTournamentRefundsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTournamentRefunds>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentRefunds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTournamentRefundsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTournamentRefunds>>
  > = ({ signal }) => getTournamentRefunds(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTournamentRefunds>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTournamentRefundsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTournamentRefunds>>
>;
export type GetTournamentRefundsQueryError = ErrorType<unknown>;

/**
 * @summary List card refunds for a tournament (newest first, staff-only)
 */

export function useGetTournamentRefunds<
  TData = Awaited<ReturnType<typeof getTournamentRefunds>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentRefunds>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTournamentRefundsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List knockouts for a tournament (newest first)
 */
export const getGetTournamentKnockoutsUrl = (id: number) => {
  return `/api/tournaments/${id}/knockouts`;
};

export const getTournamentKnockouts = async (
  id: number,
  options?: RequestInit,
): Promise<Knockout[]> => {
  return customFetch<Knockout[]>(getGetTournamentKnockoutsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTournamentKnockoutsQueryKey = (id: number) => {
  return [`/api/tournaments/${id}/knockouts`] as const;
};

export const getGetTournamentKnockoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTournamentKnockouts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentKnockouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTournamentKnockoutsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTournamentKnockouts>>
  > = ({ signal }) => getTournamentKnockouts(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTournamentKnockouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTournamentKnockoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTournamentKnockouts>>
>;
export type GetTournamentKnockoutsQueryError = ErrorType<unknown>;

/**
 * @summary List knockouts for a tournament (newest first)
 */

export function useGetTournamentKnockouts<
  TData = Awaited<ReturnType<typeof getTournamentKnockouts>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTournamentKnockouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTournamentKnockoutsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all announcements (admin)
 */
export const getListAnnouncementsUrl = () => {
  return `/api/announcements`;
};

export const listAnnouncements = async (
  options?: RequestInit,
): Promise<Announcement[]> => {
  return customFetch<Announcement[]>(getListAnnouncementsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAnnouncementsQueryKey = () => {
  return [`/api/announcements`] as const;
};

export const getListAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAnnouncements>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAnnouncements>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAnnouncementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAnnouncements>>
  > = ({ signal }) => listAnnouncements({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAnnouncements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAnnouncements>>
>;
export type ListAnnouncementsQueryError = ErrorType<unknown>;

/**
 * @summary List all announcements (admin)
 */

export function useListAnnouncements<
  TData = Awaited<ReturnType<typeof listAnnouncements>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAnnouncements>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAnnouncementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create an announcement
 */
export const getCreateAnnouncementUrl = () => {
  return `/api/announcements`;
};

export const createAnnouncement = async (
  createAnnouncementBody: CreateAnnouncementBody,
  options?: RequestInit,
): Promise<Announcement> => {
  return customFetch<Announcement>(getCreateAnnouncementUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAnnouncementBody),
  });
};

export const getCreateAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnnouncement>>,
    TError,
    { data: BodyType<CreateAnnouncementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAnnouncement>>,
  TError,
  { data: BodyType<CreateAnnouncementBody> },
  TContext
> => {
  const mutationKey = ["createAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAnnouncement>>,
    { data: BodyType<CreateAnnouncementBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAnnouncement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAnnouncement>>
>;
export type CreateAnnouncementMutationBody = BodyType<CreateAnnouncementBody>;
export type CreateAnnouncementMutationError = ErrorType<unknown>;

/**
 * @summary Create an announcement
 */
export const useCreateAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAnnouncement>>,
    TError,
    { data: BodyType<CreateAnnouncementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAnnouncement>>,
  TError,
  { data: BodyType<CreateAnnouncementBody> },
  TContext
> => {
  return useMutation(getCreateAnnouncementMutationOptions(options));
};

/**
 * @summary Get the currently active announcement (public)
 */
export const getGetActiveAnnouncementUrl = () => {
  return `/api/announcements/active`;
};

export const getActiveAnnouncement = async (
  options?: RequestInit,
): Promise<Announcement | null> => {
  return customFetch<Announcement | null>(getGetActiveAnnouncementUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetActiveAnnouncementQueryKey = () => {
  return [`/api/announcements/active`] as const;
};

export const getGetActiveAnnouncementQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveAnnouncement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActiveAnnouncement>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveAnnouncementQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveAnnouncement>>
  > = ({ signal }) => getActiveAnnouncement({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveAnnouncement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveAnnouncementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveAnnouncement>>
>;
export type GetActiveAnnouncementQueryError = ErrorType<unknown>;

/**
 * @summary Get the currently active announcement (public)
 */

export function useGetActiveAnnouncement<
  TData = Awaited<ReturnType<typeof getActiveAnnouncement>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActiveAnnouncement>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveAnnouncementQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update an announcement
 */
export const getUpdateAnnouncementUrl = (id: number) => {
  return `/api/announcements/${id}`;
};

export const updateAnnouncement = async (
  id: number,
  updateAnnouncementBody: UpdateAnnouncementBody,
  options?: RequestInit,
): Promise<Announcement> => {
  return customFetch<Announcement>(getUpdateAnnouncementUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateAnnouncementBody),
  });
};

export const getUpdateAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnnouncement>>,
    TError,
    { id: number; data: BodyType<UpdateAnnouncementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAnnouncement>>,
  TError,
  { id: number; data: BodyType<UpdateAnnouncementBody> },
  TContext
> => {
  const mutationKey = ["updateAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAnnouncement>>,
    { id: number; data: BodyType<UpdateAnnouncementBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAnnouncement(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAnnouncement>>
>;
export type UpdateAnnouncementMutationBody = BodyType<UpdateAnnouncementBody>;
export type UpdateAnnouncementMutationError = ErrorType<unknown>;

/**
 * @summary Update an announcement
 */
export const useUpdateAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnnouncement>>,
    TError,
    { id: number; data: BodyType<UpdateAnnouncementBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAnnouncement>>,
  TError,
  { id: number; data: BodyType<UpdateAnnouncementBody> },
  TContext
> => {
  return useMutation(getUpdateAnnouncementMutationOptions(options));
};

/**
 * @summary Delete an announcement
 */
export const getDeleteAnnouncementUrl = (id: number) => {
  return `/api/announcements/${id}`;
};

export const deleteAnnouncement = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteAnnouncementUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAnnouncementMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnnouncement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAnnouncement>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAnnouncement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAnnouncement>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAnnouncement(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAnnouncementMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAnnouncement>>
>;

export type DeleteAnnouncementMutationError = ErrorType<unknown>;

/**
 * @summary Delete an announcement
 */
export const useDeleteAnnouncement = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAnnouncement>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAnnouncement>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAnnouncementMutationOptions(options));
};

/**
 * @summary List weekly financial summary email schedules (Owner only)
 */
export const getListFinancialEmailSchedulesUrl = () => {
  return `/api/financial-email-schedules`;
};

export const listFinancialEmailSchedules = async (
  options?: RequestInit,
): Promise<FinancialEmailSchedule[]> => {
  return customFetch<FinancialEmailSchedule[]>(
    getListFinancialEmailSchedulesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListFinancialEmailSchedulesQueryKey = () => {
  return [`/api/financial-email-schedules`] as const;
};

export const getListFinancialEmailSchedulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFinancialEmailSchedules>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFinancialEmailSchedules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFinancialEmailSchedulesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFinancialEmailSchedules>>
  > = ({ signal }) =>
    listFinancialEmailSchedules({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFinancialEmailSchedules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFinancialEmailSchedulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFinancialEmailSchedules>>
>;
export type ListFinancialEmailSchedulesQueryError = ErrorType<unknown>;

/**
 * @summary List weekly financial summary email schedules (Owner only)
 */

export function useListFinancialEmailSchedules<
  TData = Awaited<ReturnType<typeof listFinancialEmailSchedules>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFinancialEmailSchedules>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFinancialEmailSchedulesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a financial email schedule
 */
export const getCreateFinancialEmailScheduleUrl = () => {
  return `/api/financial-email-schedules`;
};

export const createFinancialEmailSchedule = async (
  createFinancialEmailScheduleBody: CreateFinancialEmailScheduleBody,
  options?: RequestInit,
): Promise<FinancialEmailSchedule> => {
  return customFetch<FinancialEmailSchedule>(
    getCreateFinancialEmailScheduleUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createFinancialEmailScheduleBody),
    },
  );
};

export const getCreateFinancialEmailScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFinancialEmailSchedule>>,
    TError,
    { data: BodyType<CreateFinancialEmailScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFinancialEmailSchedule>>,
  TError,
  { data: BodyType<CreateFinancialEmailScheduleBody> },
  TContext
> => {
  const mutationKey = ["createFinancialEmailSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFinancialEmailSchedule>>,
    { data: BodyType<CreateFinancialEmailScheduleBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFinancialEmailSchedule(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFinancialEmailScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFinancialEmailSchedule>>
>;
export type CreateFinancialEmailScheduleMutationBody =
  BodyType<CreateFinancialEmailScheduleBody>;
export type CreateFinancialEmailScheduleMutationError = ErrorType<unknown>;

/**
 * @summary Create a financial email schedule
 */
export const useCreateFinancialEmailSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFinancialEmailSchedule>>,
    TError,
    { data: BodyType<CreateFinancialEmailScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFinancialEmailSchedule>>,
  TError,
  { data: BodyType<CreateFinancialEmailScheduleBody> },
  TContext
> => {
  return useMutation(getCreateFinancialEmailScheduleMutationOptions(options));
};

/**
 * @summary Update a financial email schedule
 */
export const getUpdateFinancialEmailScheduleUrl = (id: number) => {
  return `/api/financial-email-schedules/${id}`;
};

export const updateFinancialEmailSchedule = async (
  id: number,
  updateFinancialEmailScheduleBody: UpdateFinancialEmailScheduleBody,
  options?: RequestInit,
): Promise<FinancialEmailSchedule> => {
  return customFetch<FinancialEmailSchedule>(
    getUpdateFinancialEmailScheduleUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateFinancialEmailScheduleBody),
    },
  );
};

export const getUpdateFinancialEmailScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFinancialEmailSchedule>>,
    TError,
    { id: number; data: BodyType<UpdateFinancialEmailScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFinancialEmailSchedule>>,
  TError,
  { id: number; data: BodyType<UpdateFinancialEmailScheduleBody> },
  TContext
> => {
  const mutationKey = ["updateFinancialEmailSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFinancialEmailSchedule>>,
    { id: number; data: BodyType<UpdateFinancialEmailScheduleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFinancialEmailSchedule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFinancialEmailScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFinancialEmailSchedule>>
>;
export type UpdateFinancialEmailScheduleMutationBody =
  BodyType<UpdateFinancialEmailScheduleBody>;
export type UpdateFinancialEmailScheduleMutationError = ErrorType<unknown>;

/**
 * @summary Update a financial email schedule
 */
export const useUpdateFinancialEmailSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFinancialEmailSchedule>>,
    TError,
    { id: number; data: BodyType<UpdateFinancialEmailScheduleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFinancialEmailSchedule>>,
  TError,
  { id: number; data: BodyType<UpdateFinancialEmailScheduleBody> },
  TContext
> => {
  return useMutation(getUpdateFinancialEmailScheduleMutationOptions(options));
};

/**
 * @summary Delete a financial email schedule
 */
export const getDeleteFinancialEmailScheduleUrl = (id: number) => {
  return `/api/financial-email-schedules/${id}`;
};

export const deleteFinancialEmailSchedule = async (
  id: number,
  options?: RequestInit,
): Promise<DeleteResponse> => {
  return customFetch<DeleteResponse>(getDeleteFinancialEmailScheduleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteFinancialEmailScheduleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFinancialEmailSchedule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFinancialEmailSchedule>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteFinancialEmailSchedule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFinancialEmailSchedule>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteFinancialEmailSchedule(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFinancialEmailScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFinancialEmailSchedule>>
>;

export type DeleteFinancialEmailScheduleMutationError = ErrorType<unknown>;

/**
 * @summary Delete a financial email schedule
 */
export const useDeleteFinancialEmailSchedule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFinancialEmailSchedule>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFinancialEmailSchedule>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteFinancialEmailScheduleMutationOptions(options));
};

/**
 * @summary Run a schedule immediately and email recipients
 */
export const getSendFinancialEmailScheduleNowUrl = (id: number) => {
  return `/api/financial-email-schedules/${id}/send-now`;
};

export const sendFinancialEmailScheduleNow = async (
  id: number,
  options?: RequestInit,
): Promise<FinancialEmailSendNowResponse> => {
  return customFetch<FinancialEmailSendNowResponse>(
    getSendFinancialEmailScheduleNowUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getSendFinancialEmailScheduleNowMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendFinancialEmailScheduleNow>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendFinancialEmailScheduleNow>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["sendFinancialEmailScheduleNow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendFinancialEmailScheduleNow>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return sendFinancialEmailScheduleNow(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendFinancialEmailScheduleNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendFinancialEmailScheduleNow>>
>;

export type SendFinancialEmailScheduleNowMutationError = ErrorType<unknown>;

/**
 * @summary Run a schedule immediately and email recipients
 */
export const useSendFinancialEmailScheduleNow = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendFinancialEmailScheduleNow>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendFinancialEmailScheduleNow>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getSendFinancialEmailScheduleNowMutationOptions(options));
};

/**
 * @summary Request a presigned URL to upload an image to object storage
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  requestUploadUrlBody: RequestUploadUrlBody,
  options?: RequestInit,
): Promise<RequestUploadUrlResponse> => {
  return customFetch<RequestUploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestUploadUrlBody),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<RequestUploadUrlBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<RequestUploadUrlBody>;
export type RequestUploadUrlMutationError = ErrorType<unknown>;

/**
 * @summary Request a presigned URL to upload an image to object storage
 */
export const useRequestUploadUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary List app-level secrets / configuration (Owner only)
 */
export const getListAppSettingsUrl = () => {
  return `/api/app-settings`;
};

export const listAppSettings = async (
  options?: RequestInit,
): Promise<AppSettingListResponse> => {
  return customFetch<AppSettingListResponse>(getListAppSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAppSettingsQueryKey = () => {
  return [`/api/app-settings`] as const;
};

export const getListAppSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAppSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAppSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAppSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppSettings>>> = ({
    signal,
  }) => listAppSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAppSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAppSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAppSettings>>
>;
export type ListAppSettingsQueryError = ErrorType<unknown>;

/**
 * @summary List app-level secrets / configuration (Owner only)
 */

export function useListAppSettings<
  TData = Awaited<ReturnType<typeof listAppSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAppSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAppSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Auto-detected and effective public URLs (Owner only)
 */
export const getGetDomainsInfoUrl = () => {
  return `/api/app-settings/domains-info`;
};

export const getDomainsInfo = async (
  options?: RequestInit,
): Promise<DomainsInfo> => {
  return customFetch<DomainsInfo>(getGetDomainsInfoUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDomainsInfoQueryKey = () => {
  return [`/api/app-settings/domains-info`] as const;
};

export const getGetDomainsInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getDomainsInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDomainsInfo>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDomainsInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomainsInfo>>> = ({
    signal,
  }) => getDomainsInfo({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDomainsInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDomainsInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDomainsInfo>>
>;
export type GetDomainsInfoQueryError = ErrorType<unknown>;

/**
 * @summary Auto-detected and effective public URLs (Owner only)
 */

export function useGetDomainsInfo<
  TData = Awaited<ReturnType<typeof getDomainsInfo>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDomainsInfo>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDomainsInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set the value of an app setting (Owner only)
 */
export const getSetAppSettingUrl = (key: string) => {
  return `/api/app-settings/${key}`;
};

export const setAppSetting = async (
  key: string,
  setAppSettingBody: SetAppSettingBody,
  options?: RequestInit,
): Promise<AppSettingItemResponse> => {
  return customFetch<AppSettingItemResponse>(getSetAppSettingUrl(key), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setAppSettingBody),
  });
};

export const getSetAppSettingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAppSetting>>,
    TError,
    { key: string; data: BodyType<SetAppSettingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAppSetting>>,
  TError,
  { key: string; data: BodyType<SetAppSettingBody> },
  TContext
> => {
  const mutationKey = ["setAppSetting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAppSetting>>,
    { key: string; data: BodyType<SetAppSettingBody> }
  > = (props) => {
    const { key, data } = props ?? {};

    return setAppSetting(key, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAppSettingMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAppSetting>>
>;
export type SetAppSettingMutationBody = BodyType<SetAppSettingBody>;
export type SetAppSettingMutationError = ErrorType<unknown>;

/**
 * @summary Set the value of an app setting (Owner only)
 */
export const useSetAppSetting = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAppSetting>>,
    TError,
    { key: string; data: BodyType<SetAppSettingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setAppSetting>>,
  TError,
  { key: string; data: BodyType<SetAppSettingBody> },
  TContext
> => {
  return useMutation(getSetAppSettingMutationOptions(options));
};

/**
 * @summary Clear a stored app setting value (Owner only)
 */
export const getClearAppSettingUrl = (key: string) => {
  return `/api/app-settings/${key}`;
};

export const clearAppSetting = async (
  key: string,
  options?: RequestInit,
): Promise<AppSettingItemResponse> => {
  return customFetch<AppSettingItemResponse>(getClearAppSettingUrl(key), {
    ...options,
    method: "DELETE",
  });
};

export const getClearAppSettingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearAppSetting>>,
    TError,
    { key: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearAppSetting>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ["clearAppSetting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearAppSetting>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return clearAppSetting(key, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearAppSettingMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearAppSetting>>
>;

export type ClearAppSettingMutationError = ErrorType<unknown>;

/**
 * @summary Clear a stored app setting value (Owner only)
 */
export const useClearAppSetting = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearAppSetting>>,
    TError,
    { key: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearAppSetting>>,
  TError,
  { key: string },
  TContext
> => {
  return useMutation(getClearAppSettingMutationOptions(options));
};

/**
 * @summary Set the current player's avatar image
 */
export const getSetMyAvatarUrl = () => {
  return `/api/player-auth/me/avatar`;
};

export const setMyAvatar = async (
  setMyAvatarBody: SetMyAvatarBody,
  options?: RequestInit,
): Promise<PlayerMe> => {
  return customFetch<PlayerMe>(getSetMyAvatarUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setMyAvatarBody),
  });
};

export const getSetMyAvatarMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMyAvatar>>,
    TError,
    { data: BodyType<SetMyAvatarBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMyAvatar>>,
  TError,
  { data: BodyType<SetMyAvatarBody> },
  TContext
> => {
  const mutationKey = ["setMyAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMyAvatar>>,
    { data: BodyType<SetMyAvatarBody> }
  > = (props) => {
    const { data } = props ?? {};

    return setMyAvatar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMyAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMyAvatar>>
>;
export type SetMyAvatarMutationBody = BodyType<SetMyAvatarBody>;
export type SetMyAvatarMutationError = ErrorType<unknown>;

/**
 * @summary Set the current player's avatar image
 */
export const useSetMyAvatar = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMyAvatar>>,
    TError,
    { data: BodyType<SetMyAvatarBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setMyAvatar>>,
  TError,
  { data: BodyType<SetMyAvatarBody> },
  TContext
> => {
  return useMutation(getSetMyAvatarMutationOptions(options));
};
